{
  "heroic_approval": {
    "karma": "Vertrauen",
    "setting_hint": "Zeigt die gutgeschriebenen Erfahrungspunkte und Vertrauen, wenn eine gute Tat bestätigt wurde."
  },
  "category_milestones": {
    "description": "Sammle Kategorie-Erfahrungspunkte, schalte Titel und Abzeichen frei und wähle einen Titel für dein Profil."
  },
  "level_up": {
    "setting": "Popups bei persönlichen Levelaufstiegen anzeigen"
  },
  "profile_identity": {
    "subtitle": "Dein Profil"
  },
  "adventureFlow": {
    "intro": "Dein Einsatz zählt. Aus echten guten Taten wird ein Engagement, das dich und deine Umgebung weiterbringt."
  },
  "flyers": {
    "adventurer": {
      "title": "Dein Engagement auf einen Blick",
      "body": "Gute Taten, Erfahrung, Gruppen und echte Vorteile: Der Mitglieder-Flyer zeigt dir, wie Goodvale funktioniert. Zum Herunterladen und Teilen.",
      "alt": "Vorschau des Goodvale-Mitglieder-Flyers"
    }
  },
  "partnersPage": {
    "intro": "Goodvale macht Engagement sichtbar: Menschen tun Gutes, sammeln Erfahrung und entwickeln sich weiter. Dein Betrieb würdigt diesen Einsatz mit passenden Angeboten und wird von neuen Kundinnen und Kunden entdeckt.",
    "example": "Beispiel: Dein Café bietet 10 % Rabatt ab Rang E, einmal pro Person und Woche.",
    "steps": [
      {
        "title": "Engagieren & entdecken",
        "body": "Lea tut Gutes, erreicht Rang E und entdeckt dein Café und den passenden Vorteil in Goodvale."
      },
      {
        "title": "QR-Pass oder digital",
        "body": "Lea zeigt ihren QR-Pass zum Scannen. Bei einem digitalen Angebot löst sie es in der App ein und nutzt den bereitgestellten Code. Goodvale prüft Voraussetzungen und Limits."
      },
      {
        "title": "Vorteil erhalten",
        "body": "Dein Team bestätigt vor Ort die Einlösung und gewährt den Rabatt an der Kasse: Aus 10 € werden 9 €. Die Einlösung wird gespeichert."
      }
    ]
  },
  "class_change": {
    "current": "Dein aktueller Schwerpunkt",
    "preview": "Dein neuer Schwerpunkt",
    "preview_hint": "Wähle ein Schwerpunkt-Icon, um Fähigkeiten und Boni zu entdecken.",
    "xp_safe": "Deine bisherigen Erfahrungspunkte bleiben erhalten",
    "title": "Schwerpunkt ändern",
    "explanation": "Du kannst deinen Schwerpunkt innerhalb von sieben Tagen nach der Registrierung einmalig ändern. Deine bisherigen Erfahrungspunkte und Level bleiben unverändert. Laufende gute Taten behalten ihre gespeicherten Boni.",
    "choose": "Neuen Schwerpunkt auswählen",
    "confirm": "Möchtest du diesen Schwerpunkt endgültig wählen? Du kannst deinen Schwerpunkt danach nicht erneut ändern. Deine bisherigen Erfahrungspunkte bleiben unverändert.",
    "save": "Schwerpunkt einmalig wechseln",
    "success": "Dein Schwerpunkt wurde geändert. Deine bisherigen Erfahrungspunkte bleiben erhalten.",
    "error": "Der Schwerpunkt konnte nicht geändert werden.",
    "load_error": "Die Schwerpunkte konnten nicht geladen werden.",
    "used": "Du hast deinen einmaligen Schwerpunktwechsel bereits genutzt.",
    "unavailable": "Der Schwerpunktwechsel ist nicht verfügbar. Er ist nur während der ersten sieben Tage möglich."
  },
  "ui_text": {
    "admin_dashboard": {
      "intro": "Aggregierte Echtzeit-Informationen zu Moderation, Partneranträgen, Gruppen, Benutzern und Audit-Logs.",
      "guilds_stat": "Gruppen",
      "active_guilds": "Aktive Gruppen im Spiel",
      "no_pending_deeds": "Keine offenen guten Taten zur Prüfung in der Community-Prüfung vorhanden.",
      "recent_users_intro": "Kürzlich registrierte Mitglieder & Profile",
      "guilds_and_foundings": "Gruppen & Gründungen",
      "guilds_intro": "Gruppenübersicht und Gruppenpunkte",
      "all_guilds": "Alle Gruppen",
      "no_guilds": "Bisher sind keine Gruppen gegründet worden."
    },
    "admin_class_category": {
      "title": "Schwerpunkte & Kategorien Konfigurator",
      "intro": "Konfiguriere Schwerpunkte, Perks sowie Gute-Taten- und Partnerkategorien inkl. Soft-Delete.",
      "loading_classes": "Lade Schwerpunkte & Perks...",
      "no_classes": "Keine Schwerpunkte vorhanden.",
      "general_xp_bonus": "Allgemeiner Gute-Taten-Erfahrungspunkte-Bonus",
      "cooldown_reduction": "Gute-Taten-Wartezeit-Reduzierung"
    },
    "partner_offer_editor": {
      "good_deed_requirement": "Bestätigte gute Tat / Vorhaben (optional)",
      "map_intro": "Klicke direkt auf die Karte oder wähle eine Schnelloption, um den Standort für Mitglieder zu setzen.",
      "guild_category": "Gruppen-Kategorie",
      "max_per_adventurer": "Max. Einlösungen pro Mitglied (optional)"
    },
    "guild_members_admin": {
      "banned_adventurers": "Gesperrte Mitglieder",
      "loading_bans": "Lade gesperrte Mitglieder...",
      "no_bans": "Keine aktiven Gruppen-Sperren",
      "ban_adventurer": "Mitglied aus Gruppe bannen",
      "ban_warning": "Mitglied wird sofort aus der Gruppe entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
      "ban_reason": "Begründung für die Gruppe (Optional):"
    },
    "guild_branding": {
      "loading": "Lade Gruppen-Branding...",
      "emblem_intro": "Gestalte das modulare Gruppenlogo deiner Gruppe aus Symbol, Rahmen, Flügeln, Helmzier, Basis und Farbschema.",
      "unlock_forge": "Logo-Editor im Shop freischalten",
      "details_title": "Gruppen-Stammdaten & Aushängeschild",
      "details_intro": "Diese Informationen sind für alle Mitglieder auf der Gruppenübersicht-Startseite und in der Übersicht sichtbar.",
      "motto": "Gruppen-Motto & Philosophie / Beschreibung:",
      "location": "Gruppen-Standort (Koordinaten): *"
    },
    "guild_detail_misc": {
      "back_to_guilds": "Zurück zur Gruppenübersicht",
      "ban_confirm": "Möchtest du dieses Mitglied wirklich dauerhaft aus der Gruppe verbannen?",
      "sole_leader_warning": "Du bist der einzige Gruppenleiter. Bitte ernenne eines der verbleibenden Mitglieder zum Gruppen-Admin, um die Gruppe verlassen zu können."
    },
    "admin_tribunal_moderators": {
      "applications_intro": "Neue Bewerbungen von Mitgliedern ab Rang C erscheinen hier zur Genehmigung oder Ablehnung."
    },
    "heroic_actions_misc": {
      "rules_slots_timing": "Bei Einzelaktionen beginnt die Wartezeit mit der Erfahrungspunkte-Gutschrift. Bei Gruppenaktionen zählt sie ab der Anmeldung und startet bei der Gutschrift nicht erneut. Unter „Meine Slots“ siehst du deine aktuelle Belegung und verbleibende Wartezeiten."
    },
    "admin_heroic_actions": {
      "rank_f": "Rang F (Novize)",
      "rank_e": "Rang E (Entdecker)",
      "rank_d": "Rang D (Pionier)",
      "rank_c": "Rang C",
      "rank_b": "Rang B (Meister)",
      "rank_a": "Rang A (Elite)",
      "rank_s": "Rang S (Legende)"
    },
    "game_mechanics_misc": {
      "view_classes_ranks": "Schwerpunkte ansehen"
    },
    "guilds_misc": {
      "no_guild_intro": "Du bist aktuell in keiner Gruppe. Gründe deine eigene Gruppe oder schließe dich einer Gemeinschaft an!"
    }
  },
  "guild_rooms": {
    "hall": "Gruppenübersicht",
    "navigation": "Navigation in der Gruppenübersicht",
    "treasury": "Punktekonto",
    "shop": "Gruppen-Shop",
    "trophies": "Gemeinsame Erfolge",
    "forge": "Logo-Editor",
    "stats": "Ansehen & Statistik"
  },
  "hero_card": {
    "title": "Mitgliedervisitenkarte",
    "karma": "Vertrauen",
    "guild": "Gruppe",
    "qr": "Aktueller Mitgliedsausweis"
  },
  "dialogs": {
    "moderator_title": "Werde Teil der Community-Prüfung"
  },
  "app": {
    "adventurer": "Mitglied {{name}}",
    "rank_class": "Rang {{rank}} • {{class}}"
  },
  "world": {
    "nav": {
      "guild": "Gruppe"
    }
  },
  "common": {
    "adventurer": "Mitglied",
    "rank": "Rang {{rank}}"
  },
  "nav": {
    "dashboard": "Mitgliedsausweis",
    "talents": "Vorteile",
    "tavern": "News",
    "guilds": "Gruppen",
    "classes_ranks": "Schwerpunkte & Ränge",
    "classes": "Schwerpunkte",
    "ranks": "Ränge",
    "world_guild_mgmt": "Gruppen-Management",
    "good_deeds": "Gute Taten & EP"
  },
  "karma": {
    "title": "Vertrauen",
    "subtitle": "Dein Verhaltenskodex und deine Reputation in der Gruppe.",
    "points": "{{score}} Vertrauenspunkte",
    "open_barometer": "Vertrauens-Balken im Profil öffnen",
    "markers_title": "Vertrauens-Schwellen und Voraussetzungen",
    "marker_guild": "Gruppengründung",
    "marker_guild_detail": "Mindest-Vertrauen; Rang und gute Taten sind zusätzlich nötig.",
    "marker_tribunal": "Bewerbung für die Community-Prüfung",
    "marker_tribunal_detail": "Mindest-Vertrauen; zusätzlich ist Rang {{rank}} nötig.",
    "marker_neutral_detail": "Keine Vertrauens-Sanktion.",
    "marker_partner_detail": "Gilt von {{partner}} bis {{minimum}} Vertrauen.",
    "marker_xp": "Täglicher Erfahrungspunkte-Abzug",
    "marker_xp_detail": "Gilt von {{xp}} bis {{xpEnd}}; täglich {{percent}} % der Gesamt-Erfahrungspunkte.",
    "marker_tribunal_loss": "Prüfrecht entfällt",
    "marker_tribunal_loss_detail": "Ab {{tribunalLoss}} wird eine bestehende Prüfrolle entzogen.",
    "tier_trusty_desc": "Positives Vertrauen durch regelmäßige, verifizierte gute Taten.",
    "tier_neutral_desc": "Ausgeglichenes Vertrauen. Reiche gute Taten ein oder unterstütze deine Gruppe.",
    "tier_warned_desc": "Ab {{partner}} Vertrauen sind Partnervorteile gesperrt. Bestätigte gute Taten bauen Vertrauen wieder auf.",
    "tier_outlaw": "Täglicher Erfahrungspunkte-Abzug",
    "tier_outlaw_desc": "Von {{xp}} bis {{xpEnd}} Vertrauen werden täglich {{percent}} % deiner aktuellen Gesamt-Erfahrungspunkte abgezogen.",
    "tier_banned_desc": "Dein Konto wurde separat gesperrt. Die Kontosperre ist unabhängig vom Vertrauens-Wert.",
    "rules": "Vertrauen reicht von {{minimum}} bis {{maximum}}. Ab {{partner}} sind Partnervorteile gesperrt, ab {{xp}} gehen täglich {{percent}} % Gesamt-Erfahrungspunkte verloren und ab {{suspension}} wird das Konto {{months}} Kalendermonat(e) gesperrt.",
    "tier_restricted_desc": "Von {{suspension}} bis {{minimum}} Vertrauen wird dein Konto für {{months}} Kalendermonat(e) gesperrt. Eine separate Admin-Sperre bleibt davon unberührt.",
    "tier_released_desc": "Die temporäre Kontosperre ist abgelaufen. Bei diesem Vertrauens-Wert bleiben Partnervorteile gesperrt.",
    "moderate": "Vertrauen verwalten",
    "moderation_hint": "Abzüge durch Gruppen-Admins benötigen die Bestätigung eines System-Admins. Nach Bestätigung sieht die betroffene Person deine Begründung und deinen Namen.",
    "deduction": "Vertrauens-Abzug (1–100 Punkte)",
    "submit": "Vertrauen abziehen & benachrichtigen",
    "saved": "Vertrauens-Abzug gespeichert und Benachrichtigung erstellt.",
    "pending_saved": "Vertrauens-Abzug zur Bestätigung an den System-Admin gesendet.",
    "pending_title": "Ausstehende Vertrauens-Abzüge",
    "pending_notification": "{{actor}} beantragt −{{points}} Vertrauen für {{target}}.",
    "history": "Vertrauen · Begründete Abzüge",
    "no_penalties": "Keine Vertrauens-Abzüge vorhanden.",
    "scope": "Gruppenleitungen können Mitglieder ihrer eigenen Gruppe verwalten. Superadmins können gruppenübergreifend handeln.",
    "penalty_notification_title": "Dein Vertrauen wurde angepasst",
    "penalty_notification": "{{actor}} hat dein Vertrauen um {{delta}} Punkte angepasst. Neuer Wert: {{score}}. Begründung: {{reason}}"
  },
  "tavern": {
    "detail": {
      "back": "Zurück zu den News"
    },
    "feed": {
      "adventurer": "Mitglied {{name}}",
      "guild": "Gruppe: {{name}}",
      "xpEarned": "+{{xp}} Erfahrungspunkte erhalten",
      "partnerJoined": "Partner {{name}} ist nun Teil von Goodvale",
      "adventurerJoinedTag": "NEUES MITGLIED"
    },
    "title": "News",
    "empty": "Es ist ruhig in den News heute.",
    "rank": "Rang {{rank}}"
  },
  "guilds": {
    "decorations": {
      "stages": {
        "4": "Legendär"
      },
      "title": "Freigeschaltete Gruppendekorationen",
      "renown": "Ansehensstufe",
      "forest": "Natur",
      "bronzeFrame": "Bronzener Gruppenlogorahmen",
      "celestial": "Sterne"
    },
    "memberBanner": {
      "title": "Du bist Mitglied der Gruppe „{{name}}“",
      "memberSubtitle": "Ehre und Ansehen deinem Banner! Besuche deine Gruppenübersicht oder erkunde andere Bündnisse der Welt.",
      "guildhouseBtn": "Meine Gruppenübersicht öffnen"
    },
    "createModal": {
      "title": "Neue Gruppe gründen",
      "namePlaceholder": "Gruppenname (max. 60 Zeichen)",
      "descPlaceholder": "Gruppenphilosophie / Beschreibung (optional, max. 300 Zeichen)",
      "submit": "Gruppe gründen",
      "nameRequired": "Ein Gruppenname ist erforderlich.",
      "nameTooLong": "Gruppenname darf max. 60 Zeichen haben.",
      "locationTitle": "Gruppen-Standort",
      "emblemTitle": "Heraldisches Gruppenlogo wählen",
      "creating": "Gruppe wird gegründet…"
    },
    "createPage": {
      "subtitle": "Erschaffe ein neues Bündnis in der Gruppenwelt",
      "description": "Lege den Namen, die Philosophie, das heraldische Gruppenlogo und den Standort deiner neuen Gruppe auf der Weltkarte fest.",
      "basicInfoTitle": "1. Gruppeninformationen",
      "requirements": "Mindestens Rang {{rank}}, {{actions}} bestätigte gute Taten und {{karma}} Vertrauen. Du darfst keiner Gruppe angehören. Nach Auflösung oder Übergabe deiner eigenen Gruppe gelten {{days}} Tage Wartezeit.",
      "requirementsIntro": "Für die Gruppengründung brauchst du:",
      "rankProgress": "Rang {{required}} (aktuell: {{current}})",
      "karmaProgress": "{{required}} Vertrauen (aktuell: {{current}})",
      "cooldownUntil": "Wartezeit nach Gruppenleitung bis {{date}}",
      "cooldownReady": "{{days}} Tage Wartezeit nach Auflösung oder Übergabe einer eigenen Gruppe",
      "noGuildRequirement": "Du darfst keiner anderen Gruppe angehören.",
      "forgeHint": "Weitere Gruppenlogodesigns und Farben kannst du nach der Gründung im Logo-Editor im Gruppen-Shop mit Gruppenpunkten freischalten."
    },
    "title": "Gruppen-Zentrum",
    "subtitle": "Finde eine Gruppe oder gründe deine eigene.",
    "description": "Finde eine Gemeinschaft, die zu dir passt. Entdecke Gruppen und gestalte eure Welt durch gemeinsame gute Taten.",
    "renownPts": "Ansehenspunkte",
    "directory_title": "Gruppen-Verzeichnis",
    "directory_intro": "Entdecke andere Gruppen und schließe dich einer Gemeinschaft an.",
    "founding_title": "Eigene Gruppe gründen",
    "clear_search": "Gruppensuche leeren",
    "pagination_label": "Seiten des Gruppen-Verzeichnisses",
    "empty": "Noch keine Gruppen vorhanden.",
    "loadError": "Gruppen konnten nicht geladen werden.",
    "create": "Gruppe gründen",
    "yourGuild": "Deine Gruppe",
    "yourGuildAdmin": "Deine Gruppe (Admin)",
    "inOtherGuild": "In anderer Gruppe",
    "enterGuildhouse": "Gruppenübersicht öffnen",
    "back_to_guilds": "Alle Gruppen",
    "backToGuilds": "Zurück zur Gruppenübersicht",
    "card_description": "Ehrenhafte Gemeinschaft in der Gruppenwelt.",
    "house_status": "Gruppenübersicht-Status",
    "ausgew_hltes_gildenw": "Ausgewähltes Gruppenlogo",
    "gildenhaus": "Gruppenübersicht",
    "entdecke_andere_gild": "Entdecke andere Gruppen und schließe dich einer Gemeinschaft an.",
    "du_bist_aktuell_in_k": "Du bist aktuell in keiner Gruppe. Gründe deine eigene Gruppe oder schließe dich einer Gemeinschaft an!",
    "gilde_suchen_placeholder": "Gruppe suchen..."
  },
  "share": {
    "subtitle": "Lade andere Mitglieder ein, sich der Gruppe anzuschließen und die Welt zu erkunden!"
  },
  "pos": {
    "title": "Gruppenübersicht POS & QR-Verifikation",
    "subtitle": "Scanne Mitgliedsausweise, verifiziere Signaturen und werte Vor-Ort-Rabatte in Echtzeit aus.",
    "standby_desc": "Halte den QR-Ausweis eines Mitglieds vor die Kamera."
  },
  "qr_pass": {
    "modal_badge": "Offizieller Gruppen-Ausweis"
  },
  "profile_v2": {
    "progress_line": "Rang {{rank}} · Level {{level}} · {{xp}} EP",
    "preferences": "Darstellung & Sprache",
    "moderator_title": "Community-Prüfungsmoderator werden",
    "moderator_help": "Ab Rang {{rank}} und {{karma}} Vertrauen kannst du dich bewerben. Erst nach Admin-Freigabe werden dir unabhängige Prüfungen zugewiesen.",
    "delete_confirm": "Möchtest du dein Konto wirklich dauerhaft anonymisieren? Beweisdateien und Kontaktdaten werden gelöscht. Falls du das letzte Mitglied deiner Gruppe bist, wird auch die Gruppe endgültig gelöscht."
  },
  "map_v2": {
    "guilds": "Gruppen"
  },
  "chats_v2": {
    "permission_guild": "Personen in derselben Gruppe wie ich",
    "subtitle": "Private Gespräche zwischen Mitgliedern. Die Gruppenorganisation findet im Gruppenchat statt.",
    "search": "Mitglied suchen …",
    "rank": "Rang {{rank}}",
    "rank_class": "Rang {{rank}} · {{heroClass}}"
  },
  "game_mechanics": {
    "groups": {
      "text": "Gruppenleitungen dürfen freiwillige, nicht kommerzielle Gruppenaktionen ausrufen. Mitglieder melden sich an und bestätigen ihre Teilnahme nach Beginn. Der Organisator verteilt die Gesamt-Erfahrungspunkte auf bestätigte Teilnehmende; niemand darf mehr als 50 % erhalten. Die Community-Prüfung prüft die Verteilung. Partner dürfen daraus keine verdeckten Arbeitsaufträge machen."
    },
    "removed": {
      "text": "Es gibt keine käufliche oder übertragbare Spielwährung. Fortschritt entsteht ausschließlich durch bestätigte gute Taten und kann weder gekauft noch zwischen Personen übertragen werden. Gruppen und Partner vergeben keine bezahlten Aufträge und erhalten keinen Anteil an deiner Erfahrung. Auch Abkürzungen beim Rangaufstieg oder steuerähnliche Spielmechaniken gibt es nicht."
    },
    "ai_abuse": {
      "text": "Goodvale basiert auf real erbrachten Taten und gegenseitigem Vertrauen. Die missbräuchliche Nutzung von KI zur Erstellung, Fälschung oder Manipulation von guten Taten und Nachweisen ist strengstens untersagt. Jeder festgestellte KI-Missbrauch wird mit negativem Vertrauen und gegebenenfalls mit dem Bannen des Kontos bestraft."
    },
    "karma": {
      "neutral": {
        "title": "Keine Vertrauens-Sanktion"
      },
      "xp": {
        "title": "Zusätzlich täglicher Erfahrungspunkte-Abzug",
        "text": "Einmal pro UTC-Tag werden {{percent}} % der aktuellen Gesamt-Erfahrungspunkte abgezogen. Der Prozentsatz ist in den Systemeinstellungen änderbar. Kategorie-Erfahrungspunkte bleiben erhalten; Level und Rang werden neu berechnet."
      },
      "tribunal": {
        "title": "Prüfrecht entfällt",
        "text": "Ab {{tribunalLoss}} Vertrauen wird eine bestehende Prüfrolle entzogen; eine offene Bewerbung wird zurückgesetzt. Nach Erholung ist eine neue Bewerbung nötig. Dafür gelten Rang {{tribunalRank}} und mindestens {{tribunalMinimum}} Vertrauen; die Werte sind einstellbar."
      },
      "suspension": {
        "text": "Das Konto wird für {{months}} Kalendermonat(e) gesperrt. Währenddessen gibt es keinen täglichen Erfahrungspunkte-Abzug. Danach endet diese Vertrauens-Sperre automatisch."
      },
      "title": "Vertrauen im Detail",
      "intro": "Vertrauen beginnt bei 0 und reicht von {{minimum}} bis {{maximum}}. Bestätigte gute Taten erhöhen es; abgelehnte oder zurückgezogene Taten verursachen allein keinen Abzug. Bei begründetem Fehlverhalten können Admins Vertrauen abziehen.",
      "note": "Der tägliche Abzug wird auf ganze Erfahrungspunkte aufgerundet, endet bei 0 Erfahrungspunkten und erscheint im Erfahrungspunkte-Ledger. Nach Ablauf der Sperre bleiben Partnervorteile bei gesperrtem Vertrauen gesperrt. Eine separate Admin-Sperre endet nur durch manuelle Freigabe. Bestätigte gute Taten können Vertrauen wieder aufbauen."
    },
    "subtitle": "Gute Taten einreichen, unabhängig prüfen lassen, Erfahrungspunkte sammeln und passende Partnerangebote freischalten.",
    "flow": [
      {
        "title": "1. Gute Tat",
        "description": "Du beschreibst eine bereits erbrachte, freiwillige gute Tat und reichst den nötigen datensparsamen Nachweis ein."
      },
      {
        "title": "2. Community-Prüfung",
        "description": "Die erste Prüfung ordnet Zeit und Einsatz, Planung und Abstimmung sowie Erfahrungspunkte ein. Die Erfahrungspunkte-Höhe bestimmt, ob insgesamt eine, zwei oder drei unabhängige Prüfungen und zusätzlich ein Admin nötig sind."
      },
      {
        "title": "3. Fortschritt",
        "description": "Erst die endgültige Zustimmung schreibt globale und Kategorie-Erfahrungspunkte ins unveränderliche Erfahrungspunkte-Ledger. Level, Rang und Kategorie-Level werden daraus berechnet."
      },
      {
        "title": "4. Partner",
        "description": "Angebote können Rang, Level, globale Erfahrungspunkte, Kategorie-Erfahrungspunkte oder eine bestätigte Systemaktion voraussetzen. Eingelöst wird mit einem kurzlebigen, signierten Einmal-QR-Pass."
      }
    ],
    "gildex": {
      "title": "Gruppenpunkte und Punktekonto",
      "text": "Bei einer bestätigten guten Tat erhält die bei Einreichung festgehaltene Gruppe zusätzlich einen administrierbaren Anteil der Basis-Erfahrungspunkte als Gruppenpunkte. Spieler-Erfahrungspunkte werden nicht gekürzt. Gruppenpunkte haben keinen Geldwert, sind nicht kaufbar, auszahlbar oder übertragbar und gelten nicht bei Partnern. Gruppenleitungen können damit ausschließlich interne Dekorationen und Komfortfunktionen freischalten."
    },
    "perks": {
      "title": "Schwerpunkte und Vorteile",
      "items": [
        {
          "title": "Mehr Erfahrung",
          "description": "Einige Schwerpunkte und Vorteile geben dir nach der Bestätigung zusätzliche Erfahrungspunkte für deine gute Tat."
        },
        {
          "title": "Mehr gleichzeitig tun",
          "description": "Zusätzliche Plätze erlauben dir, mehrere gute Taten oder Gruppenaktionen parallel laufen zu lassen."
        },
        {
          "title": "Kürzere Wartezeit",
          "description": "Bestimmte Fähigkeiten verkürzen die Zeit bis zu deiner nächsten Einreichung."
        },
        {
          "title": "Gemeinsam mehr erreichen",
          "description": "Der Schwerpunkt Freizeit & Begegnung erhöht die Erfahrungspunkte einer bestätigten Gruppenaktion um 10 %. Der Bonus zählt auch mit mehreren Mitgliedern mit diesem Schwerpunkt nur einmal."
        },
        {
          "title": "Fortschritt in einer Kategorie",
          "description": "Kategorie-Erfahrungspunkte stärken deinen Fortschritt im passenden Bereich. Deine Gesamt-Erfahrungspunkte bleiben davon getrennt."
        },
        {
          "title": "Vertrauen verbessern",
          "description": "Einige Vorteile stärken dein Vertrauen nach bestätigten guten Taten. Die Prüfung deiner Nachweise bleibt davon unabhängig."
        },
        {
          "title": "Erfahrungsbonus",
          "description": "Mit dem Schwerpunkt Ernährung & Lebensmittel kannst du einmal pro Kalenderwoche vor einer Einzelaktion einen kostenlosen Erfahrungsbonus einsetzen. Der konfigurierte Bonus gilt für Gesamt- und Kategorie-Erfahrungspunkte."
        }
      ]
    },
    "principles_title": "Grundsätze und Gruppenmechanik",
    "classes_link": "Alle 10 Schwerpunkte ansehen",
    "start_description": "Wähle deinen Schwerpunkt, dokumentiere deinen ersten ehrenamtlichen Beitrag und sammle verifizierte Erfahrung."
  },
  "player_progress": {
    "xp_value": "{{xp}} EP",
    "next_level_xp": "Bis zum nächsten Level: {{xp}} Erfahrungspunkte",
    "next_level_xp_short": "Noch {{xp}}"
  },
  "level_statistics": {
    "subtitle": "Level {{level}} · {{xp}} Erfahrungspunkte insgesamt. Verfolge deinen Fortschritt und die bestätigten guten Taten, mit denen du Erfahrung gesammelt hast.",
    "xp_to_talent": "Erfahrungspunkte bis zum nächsten Vorteilspunkt",
    "talent_point_ready": "Vorteilspunkt verfügbar",
    "talent_points_max": "Alle Vorteilspunkte erreicht",
    "xp": "Erfahrungspunkte",
    "monthly_xp": "Erfahrungspunkte im Monat",
    "zero": "0 Erfahrungspunkte",
    "no_history": "In den letzten zwölf Monaten gab es noch keinen Erfahrungspunkte-Zuwachs.",
    "deeds_title": "Gute Taten & erhaltene Erfahrungspunkte",
    "no_deeds": "Es gibt noch keine bestätigten guten Taten mit Erfahrungspunkten."
  },
  "slotsPage": {
    "groupStillActive": "Abgelaufen · Vorhaben noch aktiv",
    "skipSuccess": "Wartezeit übersprungen. Der Slot ist jetzt frei.",
    "skipError": "Die Wartezeit konnte nicht übersprungen werden."
  },
  "dashboard_v2": {
    "adventurer_kicker": "Goodvale · Mitglied",
    "free_adventurer": "Freies Mitglied",
    "hero_class": "Schwerpunkt",
    "class": "Schwerpunkt",
    "class_category_bonus": "Schwerpunktbonus +{{percent}} % EP",
    "other_category_bonus": "+{{percent}} % Kategorie-EP",
    "next_talent_point": "Nächster Vorteilspunkt: Lv. {{level}}",
    "no_talents": "Noch keine Vorteile freigeschaltet",
    "reset_banner": "Schwerpunktmotiv wiederherstellen",
    "talents_panel_title": "Deine Vorteile",
    "available_talent_points": "Verfügbare Vorteilspunkte",
    "open_talent_tree": "Vorteilspfade öffnen",
    "class_panel_title": "Schwerpunkt & Spezialisierung",
    "open_class_progress": "Schwerpunkt- und Rangfortschritt öffnen",
    "eyebrow": "Mitglieder-Zentrale",
    "subtitle": "Reiche gute Taten ein, verfolge Prüfentscheidungen und baue deinen persönlichen Fortschritt und Kategorie-Fortschritt aus.",
    "go_to_guild": "Zu meiner Gruppe",
    "no_guild": "Noch keiner Gruppe beigetreten",
    "browse_guilds": "Zu den Gruppen",
    "open_tribunal": "Community-Prüfung öffnen",
    "total_xp": "Gesamt-Erfahrungspunkte",
    "rank": "Rang",
    "class_and_rank": "{{heroClass}} · Rang {{rank}}",
    "xp_value": "{{xp}} EP",
    "karma": "Vertrauen",
    "apply_moderator_help": "Ab Rang C kannst du dich für unabhängige Community-Prüfungen bewerben.",
    "moderator_prompt": "Warum möchtest du Community-Prüfungsmoderator werden?",
    "status_PendingReview": "Community-Prüfung"
  },
  "partner_offers": {
    "form_level": "persönliches Level",
    "redemption_channel_help": "Wähle, wo und wie dein Angebot von Mitgliedern eingelöst werden kann.",
    "freq_once_ever": "Einmalig pro Mitglied",
    "subtitle": "Lege fest, welcher bestätigte Fortschritt ein Angebot freischaltet. Erfahrungspunkte werden dabei nicht ausgegeben.",
    "empty_desc": "Erstelle dein erstes Partnerangebot mit Rang-, Erfahrungspunkte-, Kategorie- oder Gute-Tat-Voraussetzung.",
    "modal_subtitle": "Wird im POS beim Scannen von Mitgliedern automatisch geprüft.",
    "req_karma": "Min. Vertrauen: {{karma}}",
    "responsibility_confirmation": "Ich bestätige, dass ich für Inhalt, Verfügbarkeit und Erfüllung dieses Angebots verantwortlich bin. Erfahrungspunkte werden nicht verbraucht, sind nicht übertragbar und haben keinen Geldwert.",
    "form_rank": "Mindest-Rang",
    "form_global_xp": "Gesamt-Erfahrungspunkte",
    "form_category_xp": "Kategorie-Erfahrungspunkte",
    "form_honor": "Mindest-Vertrauen",
    "req_rank": "ab Rang {{rank}}",
    "req_global_xp": "{{xp}} Gesamt-Erfahrungspunkte",
    "req_category_xp": "{{xp}} Erfahrungspunkte in {{category}}",
    "category_required": "Wähle eine Kategorie für die Kategorie-Level- oder Erfahrungspunkte-Bedingung."
  },
  "errors": {
    "medic_notice": " (inkl. Unterstützer-Bonus +1 Rang)",
    "merchant_notice": " (inkl. Spezial- / Vorteil-Bonus)",
    "tank_notice": " inkl. Sportler-Bonus"
  },
  "error": {
    "desc": "Ein unerwarteter Fehler ist aufgetreten. Unser Supportteam wurde automatisch informiert."
  },
  "register": {
    "field_contact": "Kontakt für Mitglieder",
    "field_contact_hint": "So erreichen dich Mitglieder (z. B. Telefonnummer, E-Mail oder Website).",
    "field_contact_required": "Bitte gib einen Kontakt für Mitglieder an.",
    "role_adventurer": "Mitglied",
    "role_partner": "Partner (Gruppenübersicht)",
    "class": "Schwerpunkt",
    "class_required": "Bitte wähle einen Schwerpunkt.",
    "class_title": "Wähle deinen Schwerpunkt",
    "classesSubtitle": "Zehn Schwerpunkte, ein gemeinsames Ziel: echte gute Taten sichtbar machen.",
    "class_hint": "Jeder Schwerpunkt erhält +20 % Gesamt- und Kategorie-Erfahrungspunkte für bestätigte gute Taten seiner Kategorie und einen besonderen Schwerpunktbonus.",
    "class_hint_bold": "Du kannst deinen Schwerpunkt im Profil innerhalb der ersten sieben Tage nach der Registrierung einmalig ändern. Danach ist deine Wahl endgültig. Bereits gutgeschriebene Erfahrungspunkte bleiben unverändert.",
    "field_category_note": "Wichtig für das Trigger-System der Mitglieder-Schwerpunkte.",
    "class_scout": "Begleiter",
    "class_medic": "Unterstützer",
    "class_social": "Initiator",
    "class_tank": "Sportler",
    "class_environment": "Naturfreund",
    "class_tech": "Forscher",
    "class_crafter": "Macher",
    "class_nutrition": "Versorger",
    "class_logistics": "Organisator",
    "class_guardian": "Kümmerer",
    "classes_loading": "Schwerpunktboni werden geladen …",
    "classes_error": "Schwerpunktboni konnten nicht geladen werden. Bitte versuche es erneut."
  },
  "login": {
    "subtitle": "Anmeldung für Mitglieder und Partner"
  },
  "public_profile": {
    "bio_title": "Über dieses Mitglied",
    "no_bio": "Für dieses Mitgliedsprofil wurde noch keine Beschreibung hinterlegt.",
    "karma_score": "Vertrauens-Score",
    "rank": "Rang {{rank}}",
    "visitor_title": "Mitgliedsprofil"
  },
  "location_picker": {
    "hint": "Klicke auf den Standort deines Betriebs oder deiner Gruppe. Dieser Ort wird auf der Weltkarte öffentlich angezeigt."
  },
  "admin_nav": {
    "tribunal_moderators": "Community-Prüfungsmoderatoren",
    "karma": "Vertrauens-Verwaltung",
    "class_categories": "Schwerpunkte, Perks & Kategorien",
    "heroic_actions": "Community-Prüfung",
    "xp_audits": "Erfahrungspunkte-Prüfung",
    "guild_hall": "Editor für die Gruppenübersicht"
  },
  "xp_audit": {
    "title": "Erfahrungspunkte-Auffälligkeiten",
    "intro": "Prüfe schnell vergebene Erfahrungspunkte. Zurückgehaltene Belohnungen wirken sich bis zur Entscheidung nicht auf Rang und Fortschritt aus.",
    "recent_awards": "Letzte Erfahrungspunkte-Buchungen",
    "player_pending": "Erfahrungspunkte bis zur Admin-Prüfung zurückgehalten",
    "approve": "Erfahrungspunkte freigeben",
    "reject": "Erfahrungspunkte ablehnen",
    "load_error": "Die Erfahrungspunkte-Prüffälle konnten nicht geladen werden."
  },
  "admin_tribunal_moderators": {
    "title": "Community-Prüfungsmoderatoren & Bewerbungen",
    "subtitle": "Prüfe offene Bewerbungen von Mitgliedern ab Rang C und verwalte bestehende Moderatorenrechte der Community-Prüfung.",
    "no_moderators": "Derzeit sind keine Community-Prüfungsmoderatoren aktiv.",
    "revoke_confirm_text": "Möchtest du {{name}} die Moderationsrechte für die Community-Prüfung wirklich entziehen? Die Person kann danach keine guten Taten mehr prüfen."
  },
  "admin_karma": {
    "deduct_error": "Fehler beim Abziehen von Vertrauen.",
    "award_error": "Fehler beim Gutschreiben von Vertrauen.",
    "unknown_user": "Mitglied",
    "pending_title": "Anfragen von Gruppen-Admins",
    "title": "Vertrauens-Verwaltung",
    "scope_hint": "Superadmins können das Vertrauen aller Konten verwalten, Punkte abziehen oder gutschreiben und die vollständige Historie einsehen.",
    "filter_restricted": "Erfahrungspunkte-Abzug oder Sperre (≤ {{xp}})",
    "manage_btn": "Vertrauen verwalten",
    "tier_xp_penalty": "Täglicher Erfahrungspunkte-Abzug",
    "tab_deduct": "Vertrauen abziehen (Strafe)",
    "tab_award": "Vertrauen gutschreiben (Bonus)",
    "tab_history": "Vertrauens-Historie",
    "deduct_desc": "Verringert das Vertrauen des Nutzers. Pflichtbegründung wird im Audit-Log vermerkt und per Benachrichtigung zugestellt.",
    "award_desc": "Erhöht das Vertrauen des Nutzers bei besonderen Verdiensten oder Korrekturen.",
    "submit_deduct": "Vertrauen abziehen & nutzende Person benachrichtigen",
    "submit_award": "Vertrauen gutschreiben & nutzende Person benachrichtigen",
    "deduct_success": "Vertrauens-Abzug erfolgreich gespeichert ({{delta}} Punkte).",
    "award_success": "Vertrauens-Gutschrift erfolgreich gespeichert (+{{delta}} Punkte).",
    "history_empty": "Für dieses Konto sind keine Vertrauens-Einträge vorhanden.",
    "history_title": "Audit-Log & Vertrauens-Änderungen",
    "rules_summary_title": "Vertrauens-Systemregeln",
    "rules_threshold": "Ab {{partner}} Partner-Sperre; {{xp}} bis {{xpEnd}} täglich {{percent}} % Abzug der Erfahrungspunkte; ab {{tribunal}} Entzug der Prüfrolle; ab {{suspension}} {{months}} Kalendermonat(e) Kontosperre",
    "rules_recovery": "Bestätigte gute Taten stellen schrittweise Vertrauen wieder her"
  },
  "admin_settings": {
    "filter_heroic_actions": "Gute Taten & EP - Stufen",
    "filter_progression": "Stufen & Fortschritt"
  },
  "admin_events": {
    "form_ep_multi": "Erfahrungspunkte-Multiplikator",
    "multiplier_hint": "1 = kein Erfahrungspunkte-Bonus, 1,5 = +50 % Erfahrungspunkte, 2 = doppelte Erfahrungspunkte.",
    "rewards_hint": "Zusätzliches Event-Vertrauen (0–100). Die tatsächliche Vergabe erfolgt bei der Prüfung der eingereichten Tat."
  },
  "access": {
    "unauthorized_back_dashboard": "Zum Mitglied-Dashboard",
    "role_adventurer": "Mitglied",
    "role_guildadmin": "Gruppen-Admin"
  },
  "nav_cross": {
    "goto_adventurer_dashboard": "Zum Mitglied-Dashboard",
    "tooltip_dual_role": "Du bist gleichzeitig Mitglied"
  },
  "guild": {
    "public_about": "Über unsere Gruppe",
    "public_navigation": "Gruppe entdecken",
    "public_activity": "Gruppenruhm & Aktivität",
    "already_in_guild_hint": "Du kannst nur einer Gruppe angehören. Verlasse zuerst deine aktuelle Gruppe.",
    "leave": "Gruppe verlassen",
    "leave_confirm": "Möchtest du diese Gruppe wirklich verlassen?",
    "disband_confirm": "Du bist das letzte Mitglied von {{name}}. Wenn du die Gruppe verlässt, wird sie endgültig gelöscht. Möchtest du die Gruppe wirklich auflösen?",
    "successor_warning": "Wähle vor deinem Austritt ein Mitglied als Nachfolger für die Gruppenleitung. Die Gruppe bleibt bestehen.",
    "own_house": "Deine Gruppenübersicht",
    "public_house": "Öffentliche Gruppenübersicht",
    "detail_description": "Eure gemeinsamen guten Taten hinterlassen Spuren. Mit wachsendem Gruppenruhm wird eure Halle prächtiger.",
    "tab_news": "Gruppen-Neuigkeiten",
    "tab_stammtisch": "Gruppen-Stammtisch",
    "gildex_treasury": "Gruppenschatzkammer",
    "unlocked_emotes": "Gruppen-Emotes",
    "news_title": "Gruppen-Neuigkeiten & Ankündigungen",
    "news_subtitle": "Offizielle System-Meldungen und administrative Aushänge für alle Gruppenmitglieder.",
    "news_editor_title": "Neuen Gruppen-Aushang verfassen",
    "news_title_placeholder": "z. B. Nächste Gruppenversammlung und Gute-Taten-Fokus …",
    "news_content_placeholder": "Teile alle wichtigen Informationen mit deinen Gruppenmitgliedern …",
    "news_loading": "Gruppen-Neuigkeiten werden geladen …",
    "news_system_author": "System · Gruppenzentrale",
    "no_news_desc": "Gruppen-Admins können hier offizielle Aushänge verfassen.",
    "stammtisch_title": "Gruppen-Stammtisch",
    "chat_empty_description": "Begrüße deine Gruppenmitglieder oder tauscht euch über euer Engagement aus.",
    "chat_rank": "Rang {{rank}}",
    "chat_poll_question": "Stelle deiner Gruppe eine Frage",
    "chat_action_failed": "Gruppenchat konnte nicht aktualisiert werden.",
    "more_emotes_hint": "Stammtisch Plus im Gruppen-Shop",
    "emote_cat_guild": "Gruppe",
    "emote_cat_tavern": "News",
    "admins_title": "Gruppen-Admins:",
    "leader_title": "Gruppenleiter:",
    "admin_badge": "Gruppen-Admin",
    "promote_admin_title": "Zum Gruppen-Admin befördern",
    "promote_confirm": "Möchtest du \"{{name}}\" zum Gruppen-Admin befördern?",
    "promote_success": "\"{{name}}\" wurde erfolgreich zum Gruppen-Admin befördert."
  },
  "notifications": {
    "heroic_action": {
      "approved_message": "Deine gute Tat ‚{{title}}‘ wurde freigegeben. +{{xp}} Erfahrungspunkte.",
      "review_assigned_title": "Neue Community-Prüfung",
      "appeal_approved_message": "Die gute Tat wird in einer neuen, unabhängigen Community-Prüfrunde geprüft."
    },
    "group_action": {
      "invited_message": "Dein Gruppen-Admin hat dich zu {{title}} eingeladen. Öffne die Gruppenaktionen deiner Gruppe, um dich freiwillig anzumelden.",
      "announced_message": "Deine Gruppe hat ‚{{title}}‘ ausgerufen. Die Anmeldung ist offen.",
      "approved_message": "‚{{title}}‘ wurde freigegeben. Dein Anteil: +{{xp}} Erfahrungspunkte."
    },
    "xp_audit": {
      "pending_title": "Erfahrungspunkte werden geprüft",
      "pending_message": "‚{{title}}‘ wurde freigegeben. Die Erfahrungspunkte werden wegen eines schnellen Erfahrungspunkte-Zuwachses bis zur Admin-Prüfung zurückgehalten.",
      "released_title": "Erfahrungspunkte freigegeben",
      "released_message": "Die Admin-Prüfung ist abgeschlossen. +{{xp}} Erfahrungspunkte wurden gutgeschrieben.",
      "rejected_title": "Erfahrungspunkte nicht freigegeben",
      "rejected_message": "Die Admin-Prüfung hat {{xp}} zurückgehaltene Erfahrungspunkte nicht freigegeben."
    },
    "guild_app_approved": {
      "title": "Gruppen-Beitritt bestätigt!",
      "message": "Glückwunsch! Deine Beitrittsanfrage für die Gruppe '{{guildName}}' wurde angenommen."
    },
    "guild_app_denied": {
      "title": "Gruppen-Beitritt abgelehnt",
      "message": "Deine Beitrittsanfrage für die Gruppe '{{guildName}}' wurde leider abgelehnt."
    },
    "promotion": {
      "title": "Beförderung zum Gruppen-Admin!",
      "message": "Herzlichen Glückwunsch! Du wurdest zum Gruppen-Admin befördert."
    }
  },
  "talents": {
    "branches": {
      "A": {
        "subtitle": "Kürzere Wartezeit, mehr Einreichungen und Gruppenpunkte"
      },
      "B": {
        "subtitle": "Mehr Gesamt-Erfahrungspunkte, Kategorie-Erfahrungspunkte und Vertrauen"
      },
      "C": {
        "subtitle": "Vertrauen und Gruppenaktionen stärken"
      }
    },
    "skills": {
      "A_HEROIC_ACTION_SPONSOR": {
        "title": "Gruppen-Förderer",
        "rank1_value": "+10 % Gruppenpunkte",
        "rank2_value": "+20 % Gruppenpunkte",
        "rank3_value": "+30 % Gruppenpunkte",
        "rank1": "Stufe 1: Deine bestätigten guten Taten bringen deiner Gruppe 10 % mehr Gruppenpunkte.",
        "rank2": "Stufe 2: Deine bestätigten guten Taten bringen deiner Gruppe 20 % mehr Gruppenpunkte.",
        "rank3": "Stufe 3: Deine bestätigten guten Taten bringen deiner Gruppe 30 % mehr Gruppenpunkte."
      },
      "B_TREASURE_HUNTER": {
        "rank1_value": "+5 % Gesamt-Erfahrungspunkte",
        "rank2_value": "+10 % Gesamt-Erfahrungspunkte",
        "rank3_value": "+15 % Gesamt-Erfahrungspunkte",
        "rank1": "Stufe 1: Du erhältst 5 % mehr Gesamt-Erfahrungspunkte für bestätigte gute Taten.",
        "rank2": "Stufe 2: Du erhältst 10 % mehr Gesamt-Erfahrungspunkte für bestätigte gute Taten.",
        "rank3": "Stufe 3: Du erhältst 15 % mehr Gesamt-Erfahrungspunkte für bestätigte gute Taten."
      },
      "B_BARTERER": {
        "rank1_value": "+5 % Kategorie-Erfahrungspunkte",
        "rank2_value": "+10 % Kategorie-Erfahrungspunkte",
        "rank3_value": "+15 % Kategorie-Erfahrungspunkte",
        "rank1": "Stufe 1: Du erhältst 5 % mehr Kategorie-Erfahrungspunkte für bestätigte gute Taten.",
        "rank2": "Stufe 2: Du erhältst 10 % mehr Kategorie-Erfahrungspunkte für bestätigte gute Taten.",
        "rank3": "Stufe 3: Du erhältst 15 % mehr Kategorie-Erfahrungspunkte für bestätigte gute Taten."
      },
      "B_VERIFIED_PROOF": {
        "rank1_value": "+1 Vertrauen",
        "rank2_value": "+2 Vertrauen",
        "rank3_value": "+3 Vertrauen",
        "rank1": "Stufe 1: Eine bestätigte gute Tat gibt dir 1 zusätzlichen Vertrauenspunkt.",
        "rank2": "Stufe 2: Eine bestätigte gute Tat gibt dir 2 zusätzliche Vertrauenspunkte.",
        "rank3": "Stufe 3: Eine bestätigte gute Tat gibt dir 3 zusätzliche Vertrauenspunkte."
      },
      "C_RESILIENCE": {
        "rank1_value": "bis zu +1 Vertrauen",
        "rank2_value": "bis zu +2 Vertrauen",
        "rank3_value": "bis zu +3 Vertrauen",
        "rank1": "Stufe 1: Wenn dein Vertrauen negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 1 zusätzlichen Vertrauenspunkt zurück, höchstens bis 0.",
        "rank2": "Stufe 2: Wenn dein Vertrauen negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 2 zusätzliche Vertrauenspunkte zurück, höchstens bis 0.",
        "rank3": "Stufe 3: Wenn dein Vertrauen negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 3 zusätzliche Vertrauenspunkte zurück, höchstens bis 0."
      },
      "C_GROUP_MENTOR": {
        "rank3_title": "Besonderer Anführer",
        "rank1_value": "+5 % Gruppen-Erfahrungspunkte",
        "rank2_value": "+10 % Gruppen-Erfahrungspunkte",
        "rank3_value": "+15 % Gruppen-Erfahrungspunkte",
        "rank1": "Stufe 1: Dein Beitrag erhöht die Erfahrungspunkte einer bestätigten Gruppenaktion um 5 %.",
        "rank2": "Stufe 2: Dein Beitrag erhöht die Erfahrungspunkte einer bestätigten Gruppenaktion um 10 %.",
        "rank3": "Stufe 3: Dein Beitrag erhöht die Erfahrungspunkte einer bestätigten Gruppenaktion um 15 %."
      },
      "C_GUILD_BENEFACTOR": {
        "rank1_value": "+1 Vertrauen",
        "rank2_value": "+2 Vertrauen",
        "rank3_value": "+3 Vertrauen",
        "rank1": "Stufe 1: Für eine bestätigte Gruppenaktion erhältst du 1 zusätzlichen Vertrauenspunkt.",
        "rank2": "Stufe 2: Für eine bestätigte Gruppenaktion erhältst du 2 zusätzliche Vertrauenspunkte.",
        "rank3": "Stufe 3: Für eine bestätigte Gruppenaktion erhältst du 3 zusätzliche Vertrauenspunkte."
      }
    },
    "stats": {
      "xp_bonus": {
        "label": "Gesamt-Erfahrungspunkte",
        "description": "Zusätzliche Gesamt-Erfahrungspunkte für bestätigte Einzelaktionen. Der Schwerpunktbonus gilt in der passenden Kategorie."
      },
      "cat_xp_bonus": {
        "label": "Kategorie-Erfahrungspunkte",
        "description": "Zusätzliche Erfahrungspunkte in der Kategorie deiner bestätigten Einzelaktion. Allgemeine Erfahrungspunkte-Boni zählen ebenfalls."
      },
      "gildex": {
        "label": "Gruppenpunkte",
        "description": "Deine Gruppe erhält für bestätigte Einzelaktionen zusätzlich Gruppenpunkte. Deine eigenen Erfahrungspunkte bleiben vollständig erhalten.",
        "base_xp": "{{percent}}% der Basis-Erfahrungspunkte"
      },
      "karma_rec": {
        "label": "Vertrauens-Erholung",
        "description": "Bei negativem Vertrauen bekommst du nach bestätigten guten Taten zusätzliche Punkte zurück, höchstens bis 0.",
        "talent": "+{{value}} Vertrauen (max +3, nur bei negativem Vertrauen)"
      },
      "party_ep": {
        "label": "Gruppen-Erfahrungspunkte",
        "description": "Bestätigte Gruppenaktionen bringen mehr Erfahrungspunkte. Der stärkste Schwerpunktbonus zählt einmal; Vorteilsboni kommen hinzu."
      },
      "talent_rank": "Vorteilstufe {{rank}}/3",
      "talent": "Vorteil",
      "class": "Schwerpunkt",
      "class_bonus": "Schwerpunktbonus",
      "talent_points": "Vorteilspunkte",
      "honor_heading": "Ehre & Vertrauen",
      "xp_passive": "+{{percent}}% (max +10%: Gruppe +5%, Ausbau +5%)",
      "karma_value": "+{{value}} Vertrauen",
      "karma_bonus": {
        "label": "Vertrauens-Bonus",
        "description": "So viel zusätzliches Vertrauen erhältst du für eine bestätigte gute Tat. Für den Gesamtwert gilt die aktuelle Systemgrenze.",
        "base": "0 zusätzliches Vertrauen",
        "talent": "+{{value}} Vertrauen (max +3)"
      },
      "group_karma": {
        "label": "Gruppen-Vertrauen",
        "description": "So viel zusätzliches Vertrauen erhältst du für bestätigte Gruppenaktionen.",
        "base": "0 zusätzliches Gruppen-Vertrauen",
        "talent": "+{{value}} Vertrauen (max +3)"
      }
    },
    "ui": {
      "xp_progress": "Erfahrungspunkte {{current}} / {{required}}",
      "xp_progress_aria": "Fortschritt zum nächsten Vorteilspunkt in Erfahrungspunkten",
      "all_points_reached": "Alle Vorteilspunkte erreicht",
      "upgrade_success": "Vorteil-Stufe erfolgreich aufgewertet!",
      "upgrade_failed": "Vorteil konnte nicht aufgewertet werden.",
      "tier_requirement": "Vorheriger Vorteil auf Stufe 2",
      "prereq_required": "Bringe zuerst den vorherigen Vorteil auf Stufe 2.",
      "points_required": "Du brauchst einen verfügbaren Vorteilspunkt.",
      "footer_tip": "Jede neue Vorteilstufe verbessert deinen Bonus dauerhaft.",
      "loading": "Vorteilsübersichten werden geladen...",
      "error_load": "Fehler beim Laden der Vorteilsübersichten.",
      "origin_title": "Deine Vorteile",
      "skill_tree_nav": "Wähle einen Vorteil und sieh dir seine Boni an.",
      "progression_path": "Vorteilstufen",
      "select_skill_hint": "Wähle einen Vorteil, um seinen Bonus und die nächste Stufe zu sehen."
    },
    "tree": {
      "rank": "Rang {{rank}}",
      "requires_rank": "Vorheriger Vorteil: Stufe {{rank}}"
    },
    "title": "Deine Vorteile",
    "description": "Für erreichte Level erhältst du Vorteilspunkte. Damit kannst du Boni für Erfahrung, gemeinsame Aktionen und deine nächsten Einreichungen freischalten.",
    "path_subtitles": {
      "A": "Einreichungen/Gruppenpunkte",
      "B": "Erfahrungspunkte/Vertrauen",
      "C": "Vertrauen und Gruppe"
    }
  },
  "categories": {
    "ENTERTAINMENT_GASTRO": "Freizeit & Begegnung",
    "LOGISTICS_RETAIL": "Organisation & Transport",
    "TECH_EDUCATION": "Bildung & Technik",
    "HEALTH_WELLNESS": "Gesundheit & Wohlbefinden",
    "MOBILITY_OUTDOOR": "Mobilität & Begleitung",
    "FOOD_GROCERIES": "Ernährung & Lebensmittel",
    "HARDWARE_FITNESS": "Sport & Bewegung"
  },
  "classes": {
    "roles": {
      "SCOUT": "Mobilität & Begleitung",
      "MEDIC": "Gesundheit & Wohlbefinden",
      "SOCIAL": "Freizeit & Begegnung",
      "TANK": "Sport & Bewegung",
      "TECH": "Bildung & Technik",
      "NUTRITION": "Ernährung & Lebensmittel",
      "LOGISTICS": "Organisation & Transport"
    },
    "perks": {
      "SCOUT": "Bei bestätigten guten Taten in Mobilität & Outdoor erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Du musst zwischen zwei Einreichungen 10 % kürzer warten.",
      "MEDIC": "Bei bestätigten guten Taten in Gesundheit & Wellness erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Solange dein Vertrauen negativ ist, erhältst du für jede bestätigte gute Tat einen zusätzlichen Vertrauenspunkt zurück, höchstens bis 0.",
      "SOCIAL": "Bei bestätigten guten Taten in Entertainment & Gastro erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Bei bestätigten Gruppenaktionen gibt es 10 % mehr Erfahrungspunkte für die Gruppe. Auch mit mehreren Mitgliedern mit diesem Schwerpunkt gilt der Bonus nur einmal.",
      "TANK": "Bei bestätigten guten Taten in Fitness & Ausrüstung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Du kannst eine weitere gute Tat gleichzeitig einreichen.",
      "ENVIRONMENT": "Bei bestätigten guten Taten in Umwelt & Natur erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Deine bestätigten Einzelaktionen bringen deiner Gruppe 20 % mehr Gruppenpunkte.",
      "TECH": "Bei bestätigten guten Taten in Tech & Bildung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Bei bestätigten guten Taten außerhalb von Tech & Bildung erhältst du 10 % mehr Erfahrungspunkte in der jeweiligen Kategorie.",
      "CRAFTER": "Bei bestätigten guten Taten in Handwerk & Reparatur erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Du kannst eine abgelehnte eigene Einzelaktion einmal überarbeiten und erneut prüfen lassen.",
      "NUTRITION": "Bei bestätigten guten Taten in Lebensmittel & Ernährung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Einmal pro Kalenderwoche kannst du vor einer Einzelaktion einen kostenlosen Erfahrungsbonus aktivieren. Wird die Tat bestätigt, erhältst du 25 % mehr Gesamt- und Kategorie-Erfahrungspunkte.",
      "LOGISTICS": "Bei bestätigten guten Taten in Logistik & Handel erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Einmal pro Kalenderwoche kannst du die Wartezeit bis zur nächsten Einreichung überspringen. Ein freier Platz ist weiterhin nötig.",
      "GUARDIAN": "Bei bestätigten guten Taten in der Kategorie Soziales & Gemeinschaft erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte. Für jede bestätigte gute Tat erhältst du einen zusätzlichen Vertrauenspunkt, auch bei Gruppenaktionen.",
      "default": "Spezialfähigkeit des Schwerpunkts"
    }
  },
  "perks": {
    "titles": {
      "CLASS_V2_GUARDIAN_ABILITY": "Zusätzliches Vertrauen",
      "CLASS_V2_NUTRITION_ABILITY": "Erfahrungsbonus",
      "CLASS_V2_TECH_ABILITY": "Mehr Erfahrungspunkte in anderen Kategorien",
      "CLASS_V2_ENVIRONMENT_ABILITY": "Mehr Gruppenpunkte für die Gruppe",
      "CLASS_V2_MEDIC_ABILITY": "Vertrauen schneller erholen"
    },
    "CLASS_V2_SCOUT_CATEGORY": "Bei bestätigten guten Taten in Mobilität & Outdoor erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_TANK_CATEGORY": "Bei bestätigten guten Taten in Fitness & Ausrüstung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_GUARDIAN_CATEGORY": "Bei bestätigten guten Taten in der Kategorie Soziales & Gemeinschaft erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_GUARDIAN_ABILITY": "Für jede bestätigte gute Tat erhältst du einen zusätzlichen Vertrauenspunkt, auch bei Gruppenaktionen.",
    "CLASS_V2_CRAFTER_CATEGORY": "Bei bestätigten guten Taten in Handwerk & Reparatur erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_SOCIAL_CATEGORY": "Bei bestätigten guten Taten in Entertainment & Gastro erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_SOCIAL_ABILITY": "Bei bestätigten Gruppenaktionen gibt es 10 % mehr Erfahrungspunkte für die Gruppe. Auch mit mehreren Mitgliedern mit diesem Schwerpunkt gilt der Bonus nur einmal.",
    "CLASS_V2_LOGISTICS_CATEGORY": "Bei bestätigten guten Taten in Logistik & Handel erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_NUTRITION_CATEGORY": "Bei bestätigten guten Taten in Lebensmittel & Ernährung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_NUTRITION_ABILITY": "Einmal pro Kalenderwoche kannst du vor einer Einzelaktion einen kostenlosen Erfahrungsbonus aktivieren. Wird die Tat bestätigt, erhältst du 25 % mehr Gesamt- und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_TECH_CATEGORY": "Bei bestätigten guten Taten in Tech & Bildung erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_TECH_ABILITY": "Bei bestätigten guten Taten außerhalb von Tech & Bildung erhältst du 10 % mehr Erfahrungspunkte in der jeweiligen Kategorie.",
    "CLASS_V2_ENVIRONMENT_CATEGORY": "Bei bestätigten guten Taten in Umwelt & Natur erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_ENVIRONMENT_ABILITY": "Deine bestätigten Einzelaktionen bringen deiner Gruppe 20 % mehr Gruppenpunkte.",
    "CLASS_V2_MEDIC_CATEGORY": "Bei bestätigten guten Taten in Gesundheit & Wellness erhältst du 20 % mehr Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte.",
    "CLASS_V2_MEDIC_ABILITY": "Solange dein Vertrauen negativ ist, erhältst du für jede bestätigte gute Tat einen zusätzlichen Vertrauenspunkt zurück, höchstens bis 0."
  },
  "api": {
    "guild_unlock": {
      "already_unlocked": "Diese Gruppen-Freischaltung ist bereits aktiv.",
      "insufficient_gildex": "Die Gruppenschatzkammer enthält nicht genügend Gruppenpunkte für diese Freischaltung.",
      "requires_previous_boost": "Schalte zuerst die vorherige Erfahrungspunkte-Boost-Stufe frei."
    },
    "messages": {
      "guild_statistics_members_only": "Nur Mitglieder dieser Gruppe haben Zugriff auf die Gruppenstatistik.",
      "guild_founding_rank_required": "Für die Gruppengründung benötigst du mindestens Rang {{rank}}.",
      "guild_founding_actions_required": "Für die Gruppengründung benötigst du mindestens {{count}} bestätigte gute Taten.",
      "guild_founding_karma_required": "Für die Gruppengründung benötigst du mindestens {{karma}} Vertrauen.",
      "guild_founding_cooldown": "Nach dem Ende deiner letzten Gruppenleitung musst du {{days}} Tage warten, bevor du erneut eine Gruppe gründen kannst.",
      "settings_rank_requirement_invalid": "Der Mindest-Rang muss F, E, D, C, B, A oder S sein.",
      "settings_karma_requirement_invalid": "Das Mindest-Vertrauen muss innerhalb der aktuellen Vertrauens-Grenzen und oberhalb der Grenze für den Entzug der Prüfrechte liegen.",
      "settings_karma_threshold_order_invalid": "Die Vertrauens-Schwellen müssen in gültiger Reihenfolge liegen (Sperre, Entzug der Prüfrechte, Erfahrungspunkte-Abzug, Partner-Sperre, positive Stufen).",
      "settings_karma_xp_penalty_invalid": "Der tägliche Vertrauens-Erfahrungspunkte-Abzug muss zwischen 0 und 100 Prozent liegen.",
      "guild_applicant_unavailable": "Der Bewerber kann keiner Gruppe mehr beitreten.",
      "heroic_xp_audit_pending": "Zuerst muss die ausstehende Erfahrungspunkte-Prüfung entschieden werden.",
      "heroic_xp_balance_mismatch": "Die Erfahrungspunkte-Buchungen stimmen nicht mit dem aktuellen Guthaben überein. Die Einreichung wurde nicht gelöscht.",
      "heroic_recalculate_admin_only": "Nur aktive System-Admins dürfen Erfahrungspunkte neu berechnen.",
      "heroic_tribunal_assessment_missing": "Die ursprüngliche Einstufung der Community-Prüfung fehlt.",
      "heroic_xp_ledger_missing": "Für diese Einreichung fehlt die ursprüngliche Erfahrungspunkte-Buchung.",
      "heroic_xp_participants_mismatch": "Die Erfahrungspunkte-Buchungen passen nicht mehr zu den bestätigten Teilnehmern.",
      "heroic_xp_negative_balance": "Die Erfahrungspunkte-Korrektur würde einen negativen Kontostand erzeugen.",
      "heroic_return_reviewer_only": "Nur aktive Community-Prüfungsmoderatoren oder System-Admins dürfen Einreichungen zurückschicken.",
      "class_change_unavailable": "Der einmalige Schwerpunktwechsel ist nicht mehr verfügbar oder für dieses Konto nicht erlaubt.",
      "class_change_same": "Bitte wähle einen anderen Schwerpunkt. Dein einmaliger Wechsel wurde nicht verbraucht.",
      "class_change_invalid": "Dieser Schwerpunkt ist nicht verfügbar. Dein einmaliger Wechsel wurde nicht verbraucht.",
      "benutzer_erfolgreich_aus_der_g_38": "Benutzer erfolgreich aus der Gruppe verbannt und gesperrt.",
      "gilden_sperre_erfolgreich_aufg_40": "Gruppen-Sperre erfolgreich aufgehoben.",
      "gilden_wappen_erfolgreich_hochgeladen": "Gruppenlogo erfolgreich hochgeladen und aktualisiert.",
      "gildenname_ist_erforderlich_un_23": "Gruppenname ist erforderlich und darf max. 60 Zeichen haben.",
      "gildenstandort_breiten_und_l_n_25": "Gruppenstandort (Breiten- und Längengrad) ist erforderlich.",
      "heldenklasse_erfolgreich_archi_8": "Schwerpunkt erfolgreich archiviert (Soft Delete).",
      "heldenklasse_erfolgreich_wiede_9": "Schwerpunkt erfolgreich wiederhergestellt.",
      "keine_aktive_gilden_sperre_f_r_39": "Keine aktive Gruppen-Sperre für diesen Benutzer gefunden.",
      "klassen_perk_erfolgreich_archi_12": "Schwerpunkt-Perk erfolgreich archiviert (Soft Delete).",
      "klassen_perk_erfolgreich_wiede_13": "Schwerpunkt-Perk erfolgreich wiederhergestellt.",
      "mitglied_erfolgreich_aus_der_g_36": "Mitglied erfolgreich aus der Gruppe entfernt.",
      "mitglied_erfolgreich_zum_gilde_46": "Mitglied erfolgreich zum Gruppen-Admin befördert.",
      "mitglied_nicht_in_dieser_gilde_35": "Mitglied nicht in dieser Gruppe gefunden.",
      "mitglied_nicht_in_dieser_gilde_45": "Mitglied nicht in dieser Gruppe gefunden.",
      "nur_gilden_administratoren_d_31": "Nur Gruppen-Administratoren dürfen Beitrittsanträge ansehen.",
      "nur_gilden_administratoren_d_32": "Nur Gruppen-Administratoren dürfen Beitrittsanträge bearbeiten.",
      "nur_verifizierte_mitglieder_di_31": "Nur verifizierte Mitglieder dieser Gruppe haben Zugriff auf den Gruppenchat.",
      "nur_verifizierte_mitglieder_di_32": "Nur verifizierte Mitglieder dieser Gruppe dürfen Nachrichten im Gruppenchat verfassen.",
      "nur_verifizierte_mitglieder_di_33": "Nur verifizierte Mitglieder dieser Gruppe haben Zugriff auf die Gruppen-Neuigkeiten.",
      "talent_erfolgreich_freigeschaltet": "Vorteil erfolgreich freigeschaltet!",
      "guild_successor_required": "Ernenne zuerst ein anderes Mitglied zum Gruppenleiter, bevor du die Gruppe verlässt.",
      "guild_disband_confirmation_required": "Bestätige die Auflösung der Gruppe, bevor du als letztes Mitglied austrittst.",
      "heroic_base_xp_range": "Die Basis-Erfahrungspunkte müssen für diese Einstufung zwischen {{minimum}} und {{maximum}} liegen.",
      "heroic_category_xp_range": "Die Kategorie-Erfahrungspunkte müssen für diese Einstufung zwischen {{minimum}} und {{maximum}} liegen.",
      "class_perk_hero_class_not_found": "Der Schwerpunkt wurde nicht gefunden.",
      "class_perk_not_found": "Der Schwerpunkt-Perk wurde nicht gefunden.",
      "admin_delta_range": "Die Anpassung muss zwischen −100 und +100 liegen; für den Vertrauenswert gelten die aktuellen Systemgrenzen.",
      "heroic_group_resubmit_in_guild": "Zurückgezogene Gruppenaktionen müssen über die Gruppenübersicht neu angelegt werden.",
      "heroic_review_moderator_only": "Nur Community-Prüfungsmoderatoren dürfen offene gute Taten sehen.",
      "heroic_reviewer_role_required": "Nur freigegebene Community-Prüfungsmoderatoren oder Admins dürfen prüfen.",
      "heroic_appeal_reviewer_conflict": "Wer über den Einspruch entschieden hat, darf die neue Community-Prüfrunde nicht selbst prüfen.",
      "heroic_review_guild_conflict": "Mitglieder derselben Gruppe dürfen gute Taten anderer Gruppenmitglieder nicht prüfen.",
      "heroic_review_same_player_cooldown": "Anti-Cheat: Aus Sicherheitsgründen musst du nach einer Prüfung desselben Mitglieds eine Abklingzeit abwarten.",
      "heroic_review_other_players_first": "Anti-Cheat: Du musst erst gute Taten anderer Mitglieder prüfen, bevor du dieses Mitglied erneut prüfen kannst.",
      "heroic_first_review_xp_required": "Die erste Prüfung muss Basis- und Kategorie-Erfahrungspunkte festlegen – auch bei einer Ablehnung.",
      "heroic_moderator_rank_required": "Dein Rang liegt unter der aktuellen Mindestgrenze für die Bewerbung für die Community-Prüfung.",
      "heroic_moderator_karma_required": "Dein Vertrauen liegt unter der aktuellen Mindestgrenze für die Bewerbung für die Community-Prüfung.",
      "heroic_already_moderator": "Du bist bereits Community-Prüfungsmoderator.",
      "heroic_appeal_guild_conflict": "Mitglieder derselben Gruppe dürfen keine Einsprüche von Gruppenmitgliedern entscheiden.",
      "heroic_adventurers_only": "Nur Mitglieder dürfen diese Funktion verwenden.",
      "partner_qr_requires_approved_hero": "Nur freigeschaltete Mitglieder können einen QR-Pass generieren.",
      "direct_chat_contact_restricted": "Spam-Schutz: Du darfst nur mit Benutzern chatten, die in deiner Gruppe sind oder bei denen eine Gruppen-Bewerbung aussteht.",
      "settings_xp_range_key_invalid": "Ungültiger Schlüssel für ein Gute-Taten-Erfahrungspunkte-Band.",
      "settings_xp_range_value_invalid": "Erfahrungspunkte-Bänder müssen ganze Zahlen zwischen 0 und 100000 sein.",
      "settings_xp_range_order_invalid": "Die Erfahrungspunkte-Untergrenze darf nicht über der Obergrenze liegen.",
      "settings_gildex_rate_invalid": "Die Gruppenpunkte-Rate muss zwischen 0 und 100 Prozent liegen.",
      "talent_not_found": "Vorteil existiert nicht im System.",
      "talent_max_level": "Dieser Vorteil hat bereits die Maximalstufe 3/3 erreicht.",
      "talent_no_points": "Du hast keine verfügbaren Vorteilspunkte mehr.",
      "guild_chat_locked": "Schalte zuerst den Gruppen-Stammtisch im Gruppen-Shop frei.",
      "guild_chat_members_only": "Nur Gruppenmitglieder können den Gruppenchat nutzen.",
      "guild_emotes_locked": "Schalte zuerst den Gruppen-Stammtisch und das Emote-Paket frei.",
      "guild_pin_admin_only": "Nur Gruppen-Admins können Nachrichten anheften.",
      "guild_news_title_required": "Gib einen Titel für den Gruppen-Aushang ein.",
      "guild_news_content_required": "Gib einen Inhalt für den Gruppen-Aushang ein.",
      "guild_news_admin_only": "Nur Gruppen-Admins können Aushänge erstellen.",
      "guild_news_remove_admin_only": "Nur Gruppen-Admins können Aushänge entfernen.",
      "guild_cannot_kick_self": "Du kannst dich nicht selbst aus der Gruppe entfernen.",
      "guild_kick_admin_only": "Nur Gruppen-Admins können Mitglieder entfernen.",
      "guild_cannot_kick_system_admin": "System-Admins können nicht aus einer Gruppe entfernt werden.",
      "guild_cannot_ban_self": "Du kannst dich nicht selbst aus der Gruppe bannen.",
      "guild_ban_admin_only": "Nur Gruppen-Admins können Mitglieder bannen.",
      "guild_cannot_ban_system_admin": "System-Admins können nicht aus einer Gruppe gebannt werden.",
      "guild_unban_admin_only": "Nur Gruppen-Admins können Sperren aufheben.",
      "guild_bans_admin_only": "Nur Gruppen-Admins können gesperrte Mitglieder ansehen.",
      "guild_edit_admin_only": "Nur Gruppen-Admins können Gruppendaten bearbeiten.",
      "guild_not_found": "Die Gruppe wurde nicht gefunden.",
      "guild_emblem_admin_only": "Nur Gruppen-Admins können das Gruppenlogo ändern.",
      "guild_emblem_too_large": "Die Gruppenlogodatei darf höchstens 5 MB groß sein.",
      "guild_not_member": "Du bist kein Mitglied dieser Gruppe.",
      "guild_promote_admin_only": "Nur Gruppen-Admins können Mitglieder befördern.",
      "guild_leadership_transfer_invalid": "Diese Übertragung der Gruppenleitung ist nicht möglich.",
      "guild_deputy_locked": "Schalte weitere Gruppen-Admins zuerst im Gruppen-Shop frei.",
      "guild_unlock_not_found": "Die Gruppen-Freischaltung wurde nicht gefunden.",
      "guild_gildex_admin_only": "Nur Gruppen-Admins können Gruppenpunkte ausgeben.",
      "guild_treasury_members_only": "Nur Gruppenmitglieder können das Punktekonto ansehen.",
      "group_action_members_only": "Nur Mitglieder dieser Gruppe haben Zugriff auf diese Aktion.",
      "group_action_active_members_only": "Nur aktive Gruppenmitglieder können teilnehmen.",
      "group_action_admin_only": "Nur Gruppen-Admins können Gruppenaktionen verwalten.",
      "group_action_locked": "Schalte Gruppenaktionen zuerst im Gruppen-Shop frei.",
      "guild_already_founded": "Du hast bereits eine Gruppe gegründet und kannst keine weitere gründen.",
      "guild_membership_exists": "Du bist bereits Mitglied einer Gruppe. Verlasse sie, bevor du eine neue gründest.",
      "guild_already_member": "Du bist bereits Mitglied einer Gruppe.",
      "guild_name_taken": "Dieser Gruppenname ist bereits vergeben. Wähle einen anderen Namen.",
      "partner_contact_required": "Bitte gib einen Kontakt für Mitglieder mit höchstens 250 Zeichen an.",
      "karma_minimum": "Der minimale Vertrauens-Wert ist bereits erreicht.",
      "karma_maximum": "Der maximale Vertrauens-Wert ist bereits erreicht.",
      "account_suspended_karma": "Dieses Konto wurde wegen Vertrauen {{karma}} gesperrt (Sperrgrenze: {{threshold}}). Die temporäre Sperre endet am {{until}}.",
      "karma_partner_restricted": "Partnervorteile sind bei gesperrten Konten oder negativem Vertrauen nicht verfügbar.",
      "karma_minimum_not_met": "Dein Vertrauen liegt unter dem Mindestwert für dieses Angebot.",
      "class_skip_merchant_only": "Nur Organisation & Transport können Gute Kontakte einsetzen.",
      "heroic_cooldown_slot_unavailable": "Dieser Wartezeit-Slot ist nicht mehr aktiv. Bitte die Seite aktualisieren.",
      "class_elixir_unavailable": "Erfahrungsbonus ist diese Woche nicht verfügbar.",
      "ungueltige_rolle": "Registrierungen sind nur als Mitglied oder Partner möglich.",
      "ungueltige_heldenklasse": "Der gewählte Schwerpunkt ist ungültig.",
      "invalid_gildex_price": "Der Gruppenpunkte-Preis muss eine nichtnegative ganze Zahl sein.",
      "account_successor_required": "Übertrage vor der Kontolöschung die Gruppenleitung an ein anderes Mitglied.",
      "group_xp_allocation_missing": "Bitte lege die Erfahrungspunkte-Verteilung fest.",
      "group_xp_allocation_incomplete": "Die gespeicherte Erfahrungspunkte-Verteilung ist unvollständig.",
      "group_xp_allocation_approval": "Bitte bestätige ausdrücklich die Erfahrungspunkte-Verteilung des Organisators.",
      "group_xp_allocation_stale": "Die Prüfrunde hat sich geändert. Lade die Aktion erneut und prüfe die aktuelle Erfahrungspunkte-Verteilung."
    }
  },
  "faq_page": {
    "subtitle": "Gute Taten, Community-Prüfung, Erfahrungspunkte, Gruppen, Partner und Datenschutz",
    "sections": [
      [
        "Gute Taten & EP",
        [
          [
            "Wie funktioniert Goodvale?",
            "Du meldest eine tatsächlich ausgeführte gute Tat selbst, beschreibst sie und reichst – außer bei zulässiger Selbstauskunft – einen verschlüsselten Beweis ein. Die Community-Prüfung prüft unabhängig. Erst die endgültige Bestätigung schreibt globale Erfahrungspunkte und Kategorie-Erfahrungspunkte gut."
          ],
          [
            "Wie viele Erfahrungspunkte sind angemessen?",
            "Die Admin-Einstellungen enthalten sechs Einzelbänder und acht separate Gruppenbänder. Die Gruppenpools reichen aktuell von {{groupBand1}} Erfahrungspunkten in Band 1 bis {{groupBand8}} Erfahrungspunkten in Band 8, jeweils vor Boni und Aufteilung. Die folgenden Beispiele zeigen Einzelwerte. Zeit und Einsatz umfassen Zeit, Belastung und Verantwortung; Planung und Abstimmung umfassen Planung, Abstimmung und Beteiligte. Moderatoren müssen innerhalb des daraus berechneten Bands bleiben.\n\nRichtwerte & Beispiele:\n• {{xpBand1}} Erfahrungspunkte: Umweltmeldung oder kleine konkrete Unterstützung (gering / einfach)\n• {{xpBand2}} Erfahrungspunkte: Sack Müll sammeln, Einkaufshilfe oder 1 Stunde Nachhilfe (mittel / einfach)\n• {{xpBand3}} Erfahrungspunkte: Koordinierter Workshop, Hilfsgütersortierung (mittel–hoch / koordiniert)\n• {{xpBand4}} Erfahrungspunkte: Reparatur-Nachmittag oder kleinere Sammelaktion (hoch / komplex)\n• {{xpBand5}} Erfahrungspunkte: Größere Aufräumaktion mit Team und Entsorgung (außergewöhnlich / koordiniert)\n• {{xpBand6}} Erfahrungspunkte: Mehrwöchige Patenschaft oder dauerhaftes Hilfsnetzwerk (außergewöhnlich / komplex)\n\nBei Spenden zählt der eigene Aufwand, nie der Geld- oder Warenwert."
          ],
          [
            "Was passiert mit globalen und Kategorie-Erfahrungspunkten?",
            "Bestätigte Erfahrungspunkte erhöhen dein persönliches Level und deinen Rang. Kategorie-Erfahrungspunkte erhöhen zusätzlich dein Level in der passenden Kategorie. Partner können Angebote an folgende Bedingungen knüpfen:\n• Rang oder persönliches Level\n• Gesamt-Erfahrungspunkte oder Kategorie-Erfahrungspunkte\n• Bestimmte verifizierte Systemaktionen\n\nErfahrungspunkte werden bei Partnerangeboten nicht ausgegeben oder verbraucht."
          ],
          [
            "Wie erhalte und verwende ich Kategorie-Titel und Abzeichen?",
            "In jeder der zehn Kategorien schaltest du bei Level 2, 5, 10, 30, 50, 70 und 100 jeweils einen Titel und ein Abzeichen frei. Dafür brauchst du 200, 1.250, 5.000, 45.000, 125.000, 245.000 beziehungsweise 500.000 Kategorie-Erfahrungspunkte. Im Profil kannst du aus allen aktuell freigeschalteten Titeln genau einen auswählen oder keinen anzeigen. Bei einer bestätigten guten Tat zeigt das Bestätigungs-Popup neu erreichte Meilensteine mit Abzeichen und Titel. Titel und Abzeichen sind kosmetisch und geben keine fachlichen Befugnisse. Wird eine Erfahrungspunkte-Gutschrift rückgängig gemacht, können dadurch erreichte Meilensteine wieder gesperrt werden."
          ],
          [
            "Was sind Wartezeit und parallele Einreichungen?",
            "Einzelaktionen und aktive Gruppenanmeldungen teilen sich deine Slots. Offene Aktionen und laufende Wartezeiten belegen jeweils einen Slot. Rückzug oder Abbruch geben den Slot sofort frei.\n\nBei Einzelaktionen beginnt die Wartezeit mit der Erfahrungspunkte-Gutschrift. Bei Gruppenaktionen zählt sie ab der Anmeldung und startet bei der Gutschrift nicht erneut. Unter „Meine Slots“ siehst du deine aktuelle Belegung und verbleibende Wartezeiten."
          ],
          [
            "Wie funktioniert der Erfahrungspunkte-Boost?",
            "Mitglieder mit dem Schwerpunkt Ernährung & Lebensmittel können vor einer Einzel-Einreichung einmal pro Kalenderwoche einen kostenlosen Erfahrungsbonus aktivieren:\n• +25 % Gesamt- und Kategorie-Erfahrungspunkte bei Bestätigung\n• Die Ladung wird bei Einreichung verbraucht (auch bei Ablehnung oder Rückzug)\n• Der Wochenwechsel erfolgt montags um 00:00 UTC"
          ],
          [
            "Kann ich eine gute Tat zurückziehen?",
            "Ja. Unter deinen Einreichungen kannst du eine eigene gute Tat mit dem Status „In Prüfung“ zurückziehen:\n• Laufende Prüfaufträge werden sofort beendet.\n• Es gibt keine Belohnung und keinen Vertrauens-Abzug.\n• Bereits bestätigte oder endgültig abgelehnte gute Taten können nicht zurückgezogen werden.\n• Bei Gruppenaktionen wird die gesamte Gruppenaktion abgebrochen."
          ]
        ]
      ],
      [
        "Community-Prüfung & Einspruch",
        [
          [
            "Wer darf moderieren?",
            "Ab Rang {{tribunalRank}} und {{tribunalMinimum}} Vertrauen können sich Mitglieder als Community-Prüfungsmoderatoren bewerben. Nach Freigabe durch einen Admin können sie Fälle prüfen. Ausgeschlossen sind:\n• Eigene Einreichungen oder gute Taten mit eigener Teilnahme\n• Einreichungen von Mitgliedern der eigenen Gruppe\n• Neue Prüfrunden nach einem selbst entschiedenen Einspruch"
          ],
          [
            "Gibt es Anti-Cheat-Schutzmaßnahmen bei der Moderation?",
            "Ja. Um Betrug und gegenseitige Freigaben zu verhindern, greifen automatische Anti-Cheat-Regeln:\n• Selbstprüfungsverbot & Gruppen-Mitgliedersperre\n• Automatische Abklingzeiten für wiederholte Nutzer-Paarungen\n• Pflicht zur Prüfung anderer Nutzer (Durchmischungsregel)\n\nDadurch kann es vorkommen, dass manche gute Taten erst zeitversetzt oder nach der Prüfung anderer Einreichungen in der Übersicht erscheinen."
          ],
          [
            "Wie viele Moderatoren prüfen?",
            "Die erste zugewiesene Prüfung legt Zeit und Einsatz, Planung und Abstimmung sowie Basis-Erfahrungspunkte fest. Die Anzahl erforderlicher Prüfungen richtet sich nach den Erfahrungspunkte-Schwellen:\n• Einzelprüfung: Bei kleineren guten Taten\n• Mehrfachprüfung: Bei mittleren bis großen guten Taten (Quorum entscheidet per Mehrheit)\n• Admin-Prüfung: Bei sehr hohen Erfahrungspunkte-Werten muss mindestens ein System-Admin prüfen"
          ],
          [
            "Reicht eine Ablehnung?",
            "Nur wenn für die festgelegten Erfahrungspunkte genau eine Prüfung erforderlich ist. Bei Mehrfachprüfungen entscheidet das Quorum per Mehrheit. Ein 1:1-Patt führt automatisch zu einer dritten unabhängigen Tie-Break-Prüfung. Einreichende sehen nur den laufenden Status und das Endergebnis."
          ],
          [
            "Wie funktioniert ein Einspruch?",
            "Nach einer endgültigen Ablehnung kannst du innerhalb der Frist einen begründeten Einspruch einlegen:\n• Ein System-Admin entscheidet, ob eine neue unabhängige Prüfrunde eröffnet wird.\n• Der entscheidende Admin darf diese Runde nicht selbst prüfen.\n• Der ursprüngliche Beweis muss weiter vorhanden sein."
          ],
          [
            "Was unterscheidet den Einspruch von der zweiten Prüfungschance des Schmieds?",
            "Mit einem Einspruch fechtest du die Ablehnung an. Er ist innerhalb der eingestellten Frist möglich und muss begründet werden. Ein System-Admin entscheidet, ob eine neue Prüfrunde beginnt; eine Annahme bestätigt die gute Tat noch nicht.\n\nMit dem Schwerpunktbonus „Zweite Prüfungschance“ kannst du mit dem Schwerpunkt Handwerk & Reparatur eine eigene abgelehnte Einzelaktion einmal überarbeiten und direkt erneut zur Prüfung einreichen. Dafür musst du die Beschreibung ändern oder einen neuen Nachweis hochladen und einen freien Einreichungsslot haben. Diese Fähigkeit ist nicht an die Einspruchsfrist gebunden. Während ein Einspruch läuft, kannst du sie für dieselbe Tat nicht nutzen."
          ]
        ]
      ],
      [
        "Beweise & Datenschutz",
        [
          [
            "Welche Kurzvideos kann ich als Nachweis einreichen?",
            "Du kannst Kurzvideos (MP4, max. 10 Sekunden, 10 MB) in drei Kategorien einreichen:\n• Tätigkeit: Zeigt deinen Beitrag während der Ausführung\n• Vorher: Zeigt den Ausgangszustand vor Beginn\n• Nachher: Zeigt das Ergebnis aus gleicher Perspektive"
          ],
          [
            "Werden Vorher-/Nachher-Videos schneller geprüft?",
            "Zwei eindeutige Videos mit „Vorher“ und „Nachher“ erleichtern die Prüfung und können die Verifikation beschleunigen. Eine automatische Bestätigung ist damit jedoch nicht verbunden. Achte darauf, fremde Gesichter oder private Daten zu vermeiden."
          ],
          [
            "Wie werden Beweise geschützt?",
            "Beweise werden sicher geschützt:\n• Verschlüsselte Speicherung außerhalb des Webverzeichnisses\n• Prüfung von Dateigröße, Typ, Dateisignatur und Hashes\n• Speicherung von Zeitpunkt und Version der Datenschutzbestätigung\n• Audit-Protokollierung jedes Lesezugriffs"
          ],
          [
            "Wer darf Beweise sehen?",
            "Beweise sind ausschließlich sichtbar für:\n• Dich selbst als einreichende Person\n• Den aktuell zugewiesenen Community-Prüfungsmoderator\n• Berechtigte System-Admins"
          ],
          [
            "Wie lange bleiben Beweise gespeichert?",
            "Nach der endgültigen Entscheidung wird ein Ablaufdatum gesetzt. Nach Ablauf der Aufbewahrungsfrist entfernt ein Hintergrunddienst Datei und Datensatz automatisch."
          ],
          [
            "Welche Rechte habe ich?",
            "Im Profil kannst du:\n• Eine maschinenlesbare Kopie deiner Daten herunterladen\n• Dein Konto anonymisieren (Kontaktdaten und Beweise werden entfernt, Login gesperrt)"
          ]
        ]
      ],
      [
        "Gruppen & Gruppen",
        [
          [
            "Wann kann ich eine eigene Gruppe gründen?",
            "Die World Guild ist deine erste Anlaufstelle. Dort kannst du Goodvale kennenlernen und durch bestätigte gute Taten Erfahrung sammeln. Für eine eigene Gruppe brauchst du mindestens Rang {{guildRank}}, {{guildActions}} bestätigte eigene gute Taten und {{guildKarma}} Vertrauen. Du darfst aktuell keiner Gruppe angehören. Nach Auflösung oder Übergabe deiner eigenen Gruppe musst du {{guildCooldown}} Tage warten, bevor du erneut gründest. Superadmins können diese Schwellen ändern; die aktuell geltenden Werte stehen auf der Gründungsseite."
          ],
          [
            "Wie wird der gemeinsame Einsatz sichtbar?",
            "Gemeinsamer Fortschritt und freigeschaltete Vorteile machen den Einsatz eurer Gruppe sichtbar. Verfügbare Gruppenpunkte können für interne Gruppenfunktionen ausgegeben werden."
          ],
          [
            "Wie funktionieren Gruppenaktionen?",
            "Ein Gruppenleitung kündigt eine freiwillige, nichtkommerzielle Aktion über eine eigene Formularseite an. Einladungen melden niemanden automatisch an. Alle melden sich selbst an, auch der Organisator, wenn er Erfahrungspunkte erhalten möchte. Ab Beginn bestätigt jede Person ihre tatsächliche Teilnahme selbst. Mindestens zwei Bestätigungen sind nötig. Der Organisator reicht den gemeinsamen Nachweis und die Erfahrungspunkte-Verteilung ein. Erst die endgültige Freigabe durch die Community-Prüfung gibt die Belohnung frei. Bei Absage verschwinden die Einladungsbenachrichtigungen dieser Aktion; bereits Angemeldete erhalten eine Absagebenachrichtigung. Gruppenleitungen finden den ausführlichen Leitfaden über das Info-Icon bei den Gruppenaktionen."
          ],
          [
            "Warum haben Gruppenaktionen eigene Erfahrungspunkte-Bänder?",
            "Mehrere Mitglieder teilen sich einen gemeinsamen Pool. Die Gruppenbänder sind unabhängig von den Einzelbändern einstellbar. Alle Werte gelten vor Boni und Verteilung:\n\nBand · Einzelaktion / Gruppenpool\n1 · {{xpBand1}} / {{groupBand1}} Erfahrungspunkte\n2 · {{xpBand2}} / {{groupBand2}} Erfahrungspunkte\n3 · {{xpBand3}} / {{groupBand3}} Erfahrungspunkte\n4 · {{xpBand4}} / {{groupBand4}} Erfahrungspunkte\n5 · {{xpBand5}} / {{groupBand5}} Erfahrungspunkte\n6 · {{xpBand6}} / {{groupBand6}} Erfahrungspunkte\n7 · nur Gruppe: {{groupBand7}} Erfahrungspunkte\n8 · nur Gruppe: {{groupBand8}} Erfahrungspunkte\n\nDer Pool wächst nicht automatisch mit der Teilnehmerzahl. Bei gleichen Anteilen wird der eingestellte Gruppenpool gleichmäßig geteilt; mit mehr Personen fällt der Anteil kleiner aus.\n\nZeit und Einsatz sowie Planung und Abstimmung bestimmen das Band. Gruppen haben zusätzlich „Umfangreicher Gemeinschaftseinsatz“ und „Mehrstufige Organisation“. Beide höchsten Stufen ergeben Band 8. Die Community-Prüfung beurteilt die belegten Beiträge und den tatsächlichen Organisationsaufwand."
          ],
          [
            "Wie verteilt der Organisator die Gruppen-Erfahrungspunkte?",
            "Genau 100 % werden in ganzen Prozent verteilt, ausschließlich auf bestätigte Teilnehmende. Pro Person sind 0–50 % erlaubt, auch für den Organisator. Mindestens zwei Personen brauchen einen positiven Anteil. Beispiel für fünf Personen: 40 / 25 / 15 / 10 / 10 %.\n\nDie Community-Prüfung muss der Verteilung ausdrücklich zustimmen. Während der Prüfung sind die Anteile gesperrt. Nach einer Rückgabe kann der Organisator sie überarbeiten und erneut einreichen; eine neue Prüfrunde beginnt. 0 % gibt weder Erfahrungspunkte noch Vertrauen und trägt keinen Gruppenbuff bei. Die 50-%-Grenze gilt vor persönlichen Boni."
          ],
          [
            "Was passiert, wenn jemand nicht erscheint?",
            "Wer sich abmeldet oder die Teilnahme nicht bestätigt, erhält keine Belohnung und liefert keinen Gruppenbuff. Nur angemeldete Personen werden bei Einreichung zurückgezogen. Warte deshalb auf die Bestätigung aller tatsächlich Beteiligten.\n\nFür falsche Teilnahmebestätigungen gibt es derzeit keinen eigenen Meldebutton oder eine automatische Strafe. Der Organisator kann vor der Einreichung 0 % vergeben und den Sachverhalt in der Beschreibung erläutern. Nach der Einreichung ist für Änderungen eine Rückgabe durch die Community-Prüfung nötig."
          ],
          [
            "Wie wirken Buffs auf den Gruppenpool?",
            "Zuerst wird der Pool berechnet: Basis-Erfahrungspunkte × Eventfaktor × (1 + Gruppenausbau + Gruppenbuff), anschließend abgerundet. Danach werden die gespeicherten Prozentanteile verteilt und persönliche Boni angewandt. Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte werden getrennt berechnet.\n\n• Nur bestätigte Personen mit positivem Anteil liefern Gruppenbuffs.\n• Der stärkste Bonus aus Freizeit & Begegnung zählt einmal, standardmäßig +10 %.\n• Gruppen-Mentor gibt +5 / +10 / +15 % je Rang; Beiträge mehrerer Personen werden addiert. Schwerpunkt-Gruppenbonus und Gruppen-Vorteile zusammen sind auf +50 % begrenzt.\n• Gruppenausbau zählt mit der höchsten freigeschalteten Stufe (+1 bis +5 %). Der persönliche Gruppenbonus von +5 % wirkt erst nach der Aufteilung.\n• Der Erfahrungsbonus gilt nur für Einzelaktionen; zeitlich begrenzte persönliche Buffs wirken hier nicht.\n\nBeispiel: 2.000 Basis-Erfahrungspunkte, kein Eventbonus, +5 % Gruppenausbau, +10 % Freizeit & Begegnung und +10 % Gruppen-Mentor ergeben 2.500 Pool-Erfahrungspunkte. Bei 40 / 25 / 15 / 10 / 10 % sind das 1.000 / 625 / 375 / 250 / 250 Erfahrungspunkte vor persönlichen Boni. Rest-Erfahrungspunkte bleiben bei der Aufteilung erhalten; persönliche Erfahrungspunkte werden anschließend abgerundet.\n\nSchwerpunkt- und Vorteileffekte werden bei Einreichung gespeichert, bei überarbeiteter Neueinreichung erneut erfasst. Eventfaktor und Gruppenausbau werden in der ersten Community-Prüfung festgehalten."
          ],
          [
            "Dürfen Partner Aufgaben über Gruppen vergeben?",
            "Nein. Gruppenaktionen dürfen keine bezahlte Stelle, Arbeitsschicht oder reguläre kommerzielle Leistung ersetzen. Gruppenleitungen bestätigen vor jeder Ausrufung den gemeinnützigen und freiwilligen Charakter."
          ],
          [
            "Was sind Gruppenpunkte?",
            "Gruppenpunkte sind interne Gruppen-Fortschrittspunkte ohne Geldwert:\n• Bei bestätigten guten Taten erhält die Gruppe zusätzlich einen Anteil der Basis-Erfahrungspunkte als Gruppenpunkte (deine Erfahrungspunkte bleiben unberührt).\n• Gruppenpunkte sind weder kaufbar, auszahlbar noch übertragbar.\n• Gruppenleitungen können Gruppenpunkte ausschließlich für interne Gruppendekorationen und Komfortfunktionen ausgeben."
          ],
          [
            "Was ist der Unterschied zwischen Gruppenruhm und Gruppenpunkten?",
            "• Gruppenruhm: Spiegelt den gesamten bisherigen Fortschritt der Gruppe wider und bestimmt das Aussehen der Gruppenübersicht.\n• Gruppenpunkte: Verfügbares Guthaben für interne Freischaltungen (Ausgaben verringern den Gruppenruhm nicht)."
          ]
        ]
      ],
      [
        "Partner & QR-Pass",
        [
          [
            "Wie löse ich ein Angebot ein?",
            "Öffne deinen QR-Pass:\n• Ein Partner scannt den Code und sieht berechtigte Profildaten.\n• Signatur, Ablaufzeit, Benutzerzuordnung und Bedingungen werden serverseitig geprüft."
          ],
          [
            "Kann ein Screenshot mehrfach verwendet werden?",
            "Nein. Der Pass ist signiert, läuft schnell ab und enthält eine Einmal-ID, die nach Erstnutzung dauerhaft entwertet wird."
          ],
          [
            "Sind Erfahrungspunkte Geld oder ein Zahlungsmittel?",
            "Nein. Erfahrungspunkte sind Spielfortschritt ohne Geldwert. Partnerangebote werden durch Fortschritt freigeschaltet; Partner tragen die Verantwortung für Erfüllung und Verfügbarkeit."
          ],
          [
            "Verändern Schwerpunkte den Partnerrabatt?",
            "Nein. Es gilt stets der reguläre Rabatt des Partnerangebots."
          ]
        ]
      ],
      [
        "Schwerpunkte, Perks & Vertrauen",
        [
          [
            "Kann ich meinen Schwerpunkt nach der Registrierung ändern?",
            "Ja. In deinem Profil kannst du unter „Schwerpunkt ändern“ einmalig einen anderen verfügbaren Schwerpunkt auswählen und bestätigen. Das ist nur innerhalb der ersten sieben Tage (168 Stunden) nach deiner Registrierung möglich. Das genaue Ablaufdatum steht im Profil. Nach dem Wechsel oder nach Ablauf der Frist ist kein weiterer Schwerpunktwechsel möglich."
          ],
          [
            "Was passiert beim Schwerpunktwechsel mit meinen Erfahrungspunkten und Boni?",
            "Bereits gutgeschriebene Gesamt- und Kategorie-Erfahrungspunkte werden nicht neu berechnet. Auch deine Level und dein Rang bleiben unverändert. Laufende gute Taten behalten ihre gespeicherten Boni; neue gute Taten verwenden die Boni deines neuen Schwerpunkts. Bereits verbrauchte Schwerpunktboni werden durch den Wechsel nicht zurückgesetzt."
          ],
          [
            "Welche Schwerpunkt-Perks gibt es?",
            "Alle Schwerpunkte erhalten +20 % Gesamt- und Kategorie-Erfahrungspunkte bei bestätigten guten Taten ihrer Kategorie. Die spezifischen Fähigkeiten sind:\n• Begleiter: 10 % kürzere Wartezeit\n• Sportler: +1 Slot für parallele Einreichungen\n• Kümmerer: +1 Vertrauen bei jeder bestätigten guten Tat\n• Macher: Eine abgelehnte einzelne gute Tat einmal reparieren\n• Initiator: +10 % Gruppen-Erfahrungspunkte (nicht stapelbar)\n• Organisator: Einmal wöchentlich Wartezeit überspringen\n• Versorger: Einmal wöchentlich +25 % Erfahrungspunkte auf eine Einzel-Einreichung\n• Forscher: +10 % Kategorie-Erfahrungspunkte außerhalb der eigenen Kategorie\n• Naturfreund: +20 % Gruppenpunkte aus eigenen einzelnen guten Taten\n• Unterstützer: +1 Erholungs-Vertrauen bei negativem Vertrauen (bis max. 0)"
          ],
          [
            "Sind die Vorteile je nach Schwerpunkt unterschiedlich?",
            "Nein. Alle Schwerpunkte haben dieselben Vorteilspfade und Vorteile. Dein Schwerpunkt bestimmt deinen Schwerpunktbonus; Vorteile kannst du unabhängig davon freischalten."
          ],
          [
            "Was ist Vertrauen?",
            "Vertrauen ist dein persönlicher Vertrauenswert (Skala von {{karmaMinimum}} bis {{karmaMaximum}}):\n• Beginnt bei 0 und ist keine Währung.\n• Direkte Vertrauens-Abzüge verändern Erfahrungspunkte nicht.\n• Höheres Vertrauen schaltet Vertrauensstufen frei."
          ],
          [
            "Wie bekomme ich Vertrauen?",
            "Bestätigte gute Taten belohnen mit Vertrauen:\n• Mindestens +1 Vertrauen pro bestätigter guter Tat (oder konfigurierte Belohnung)\n• Vertrauens-Vorteile erhöhen den Ertrag zusätzlich\n• Bei negativem Vertrauen greifen Erholungsboni bis max. 0\n• Ablehnungen oder Rückzüge ziehen kein Vertrauen ab\n• Bei Gruppenaktionen erhalten nur bestätigte Personen mit positivem Erfahrungspunkte-Anteil Vertrauen; 0 % gibt kein Vertrauen."
          ],
          [
            "Wer darf Vertrauen abziehen?",
            "Bei Fehlverhalten oder Betrug:\n• Gruppenleitungen dürfen Mitgliedern ihrer Gruppe Vertrauen abziehen (1–100 Punkte mit Begründung).\n• Superadmins können gruppenübergreifend handeln.\n• Du erhältst eine Benachrichtigung mit Begründung und Urheber."
          ],
          [
            "Werde ich durch negatives Vertrauen gesperrt?",
            "Von {{partner}} bis {{partnerEnd}} Vertrauen sind Partnervorteile gesperrt. Von {{xp}} bis {{xpEnd}} werden zusätzlich täglich {{percent}} % der Gesamt-Erfahrungspunkte abgezogen. Ab {{tribunalLoss}} entfällt eine bestehende Prüfrolle. Von {{suspension}} bis {{karmaMinimum}} wird das Konto {{months}} Kalendermonat(e) gesperrt. Bestätigte gute Taten bauen Vertrauen wieder auf."
          ],
          [
            "Wo verwalte ich Vertrauen als Admin?",
            "Admins finden im Profil die Funktion „Vertrauen verwalten“ zur Personensuche und Vergabe von Vertrauens-Abzügen mit Pflichtnachricht."
          ]
        ]
      ]
    ]
  },
  "admin_directory": {
    "delete_guild": "Gruppe löschen",
    "delete_guild_confirm": "Gruppe „{{name}}“ endgültig löschen? Alle Mitglieder verlassen die Gruppe, ihre Benutzerkonten bleiben erhalten. Gruppendaten und Freischaltungen werden gelöscht und laufende Gruppenaktionen abgebrochen. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "guilds": "Alle Gruppen",
    "karma": "Vertrauen",
    "karma_suspended": "Durch Vertrauen temporär gesperrt",
    "karma_suspended_until": "Vertrauens-Sperre bis {{date}}",
    "manual_suspension_separate": "Die manuelle Kontosperre wird separat verwaltet und bleibt von der Vertrauens-Sperre unabhängig.",
    "search_guilds": "Gruppenname oder Beschreibung suchen …",
    "renown": "Ansehen",
    "treasury": "Punktekonto",
    "total_xp": "Gesamt-Erfahrungspunkte",
    "manage_guild": "Gruppe verwalten",
    "view_public": "Öffentliche Gruppenseite",
    "stats_summary": "Gruppen-Kennzahlen",
    "all_time_renown": "Gesamter Ansehen",
    "rate": "Gruppenpunkte-Rate",
    "tab_karma": "Vertrauens-Moderation",
    "level_and_rank": "Stufe & Rang",
    "hero_class": "Schwerpunkt",
    "karma_score": "Vertrauens-Score",
    "guild_hall": "Gruppenübersicht ({{name}})",
    "error_loading_guild_details": "Fehler beim Laden der Gruppendetails",
    "rate_label": "Rate: {{rate}}% Basis-Erfahrungspunkte",
    "unlocked_upgrades": "Freigeschaltete Gruppen-Upgrades",
    "actions_and_gildex": "Gute Taten & Gruppenpunkte-Generierung",
    "gildex_generated": "+{{amount}} Gruppenpunkte generiert",
    "total_gildex_yield": "+{{amount}} Gruppenpunkte Gesamtertrag",
    "next_renown_stage": "Nächste Ansehensstufe: {{name}}",
    "renown_progress": "{{current}} / {{max}} Ansehen",
    "guild_members_count": "Gruppenmitglieder ({{count}})",
    "guild_leader": "Gruppenleiter",
    "xp_collected": "{{amount}} Erfahrungspunkte gesammelt",
    "no_members_in_guild": "Keine Mitglieder in dieser Gruppe.",
    "guild_announcements_count": "Gruppen-Aushänge & Ankündigungen ({{count}})",
    "class": "Schwerpunkt",
    "no_guild": "Keine Gruppe"
  },
  "classesAndRanks": {
    "title": "Schwerpunkte",
    "subtitle": "Entdecke die zehn Schwerpunkte und ihre Fähigkeiten.",
    "classes": "Schwerpunkte",
    "classesIntro": "Wähle einen Schwerpunkt, der zu deinen Interessen passt. In seiner Kategorie erhältst du mehr Erfahrungspunkte und zusätzlich eine besondere Fähigkeit.",
    "perk": "Schwerpunkt-Perk",
    "noPerk": "Der konkrete Schwerpunkt-Perk wird in deiner Schwerpunktkonfiguration angezeigt.",
    "loadError": "Die Schwerpunktkonfiguration konnte nicht geladen werden. Es werden Standardwerte angezeigt."
  },
  "ranksGuide": {
    "title": "Ränge",
    "subtitle": "Dein Rang wächst mit den Erfahrungspunkten aus bestätigten guten Taten.",
    "ranks": "Rangaufstieg",
    "ranksIntro": "Dein Rang richtet sich nach allen Erfahrungspunkten, die du durch bestätigte gute Taten gesammelt hast.",
    "xp": "Erfahrungspunkte gesamt",
    "noteTitle": "Level und Rang einfach erklärt",
    "note": "Dein Level und Rang wachsen mit deinen Gesamt-Erfahrungspunkten aus bestätigten guten Taten. In jeder Kategorie sammelst du zusätzlich eigene Kategorie-Erfahrungspunkte.",
    "whyRanksTitle": "Warum sind Ränge wichtig?",
    "whyRanksIntro": "Dein Rang zeigt deinen Fortschritt und spielt bei einigen Möglichkeiten in Goodvale eine Rolle:",
    "whyRanks": [
      {
        "title": "Eigene Gruppe gründen",
        "text": "Dafür brauchst du einen bestimmten Rang und musst weitere Voraussetzungen erfüllen."
      },
      {
        "title": "Für die Community-Prüfung bewerben",
        "text": "Ab dem erforderlichen Rang kannst du dich für die Prüfung guter Taten bewerben. Die Rolle erhältst du erst nach Freigabe."
      },
      {
        "title": "Partnerangebote nutzen",
        "text": "Einzelne Angebote können einen Mindestrang voraussetzen. Die Bedingungen stehen beim jeweiligen Angebot."
      }
    ]
  },
  "landing": {
    "eyebrow": "Dein Engagement macht einen Unterschied.",
    "title": "Das Engagement beginnt im echten Leben.",
    "guildFeature": {
      "title": "Eine Gruppe macht aus einzelnen Taten ein gemeinsames Engagement.",
      "intro": "In einer Gruppe findest du Menschen, mit denen du Ideen teilst, Hilfe organisierst und Erfolge feierst. Du kannst einer bestehenden Gemeinschaft beitreten oder eine eigene gründen. Euer Gruppenheim zeigt, was ihr zusammen erreicht habt.",
      "points": [
        {
          "title": "Zusammen handeln",
          "body": "Plant freiwillige Gruppenaktionen, meldet euch selbst an und bestätigt eure Teilnahme. Nach der Prüfung durch die Community-Prüfung wird die Gruppen-Erfahrung unter den bestätigten Teilnehmenden aufgeteilt. Schwerpunkt- und Vorteilsboni können die gemeinsame Wirkung verstärken."
        },
        {
          "title": "Die Punktekonto füllen",
          "body": "Bestätigte gute Taten bringen der zugeordneten Gruppe zusätzlich Gruppenpunkte, ohne deine eigenen Erfahrungspunkte zu verringern. Damit schaltet die Gruppe zum Beispiel Chat, Gruppenaktionen, Gestaltung für das Gruppenheim und weitere Funktionen frei."
        },
        {
          "title": "Gemeinsam profitieren",
          "body": "Schon die Gruppenmitgliedschaft gibt einen allgemeinen Erfahrungspunkte-Bonus von 5 %. Die Gruppe kann mit Gruppenpunkten zusätzliche Erfahrungspunkte-Booststufen freischalten. Es zählt die höchste gekaufte Stufe mit weiteren 1 bis 5 Prozentpunkten."
        }
      ],
      "closing": "Gruppenruhm, gemeinsame Aktionen und freigeschaltete Räume machen sichtbar, wie eure Gemeinschaft wächst. Die Gruppenleitung setzt die erspielten Gruppenpunkte für gemeinsame Vorteile ein.",
      "action": "Mitglied werden"
    },
    "partnerFeature": {
      "points": [
        {
          "title": "Sichtbar in der Region",
          "body": "Mit einem Partnerprofil stellst du dein Unternehmen, deinen Standort und deine Angebote vor. Mitglieder entdecken passende Vorteile, während sie durch echte gute Taten Fortschritte machen."
        },
        {
          "title": "Angebote passend gestalten",
          "body": "Erstelle Rabatte, Zugaben, Gutscheine oder Dienstleistungen. Du kannst Voraussetzungen wie Rang, Erfahrungspunkte, Kategorie, Vertrauen und bestätigte Event-Taten sowie Zeitraum und Kontingent festlegen."
        },
        {
          "title": "Einfach einlösen",
          "body": "Vor Ort prüfst du einen zeitlich begrenzten QR-Pass. Digitale Angebote lösen berechtigte Mitglieder selbst ein. Im Partnerbereich verwaltest du Angebote und siehst die Einlösungen."
        }
      ],
      "closing": "Partnerangebote belohnen Engagement; sie kaufen keine Erfahrungspunkte oder Stufen. Nach der Registrierung wird dein Partnerkonto freigegeben, bevor du Angebote veröffentlichst."
    },
    "roles_kicker": "Gemeinschaft",
    "roles_title": "Zusammen mehr bewirken",
    "karma_title": "Vertrauen auf einen Blick",
    "karma_intro": "Der Vertrauens-Balken zeigt, wann Vorteile gesperrt werden, Prüfrechte entfallen und weitere Folgen greifen. Wähle eine Schwelle für Details.",
    "karma_more": "Vertrauen im Detail",
    "subtitle": "Hilf anderen, unterstütze deine Umgebung und mach deinen Einsatz sichtbar. Entdecke passende Kategorien, engagiere dich gemeinsam mit deiner Gruppe und nutze Vorteile bei lokalen Partnern.",
    "join": "Gruppe beitreten",
    "classesSubtitle": "Zehn Schwerpunkte, ein gemeinsames Ziel: mit großen und kleinen Taten die Welt ein Stück besser machen.",
    "cards": [
      [
        "Mitglied",
        "Tu Gutes im Alltag – auch kleine Gesten können Großes bewirken. Sammle Erfahrungspunkte, steige im Rang auf und schalte Vorteile frei."
      ],
      [
        "Community-Prüfung",
        "Als erfahrenes Mitglied prüfst und bestätigst du eingereichte gute Taten nach strengen Qualitätskriterien."
      ],
      [
        "Gruppen",
        "Schließe dich mit Gleichgesinnten zusammen, meistere gemeinsame Herausforderungen und baut eure Gruppenkasse auf."
      ],
      [
        "Partner",
        "Unterstütze engagierte Menschen in deiner Region und belohne verifizierte gute Taten mit echten Vorteilen."
      ]
    ],
    "hero_prefix": "Gemeinsam",
    "hero_emphasis": "Gutes tun.",
    "categories_examples": "Beispiele für gute Taten und Erfahrungspunkte"
  },
  "partnerSettings": {
    "subtitle": "Verwalte dein Partnerprofil und deine exklusiven Angebote für Mitglieder."
  },
  "guild_treasury": {
    "confirm": "Möchtest du \"{{name}}\" für {{price}} Gruppenpunkte freischalten?",
    "insufficient": "Nicht genügend Gruppenpunkte.",
    "loading": "Lade Punktekonto...",
    "shop_title": "Gruppen-Shop & Katalog",
    "shop_intro": "Schalte exklusive Hallen-Themes, Stammtisch und Ausbauten für deine Gruppe frei.",
    "title": "Gruppenpunkte-Ledger & Historie",
    "rate": "Aktuelle Umwandlungsrate: {{rate}}% der Basis-Erfahrungspunkte",
    "no_money": "Gruppenpunkte können nicht gekauft werden.",
    "admin": "Nur Gruppen-Admins können Gruppenpunkte ausgeben.",
    "base": "Basis: {{xp}} Erfahrungspunkte ({{rate}}%)",
    "shop_eyebrow": "GRUPPEN-SHOP"
  },
  "guildGildexTreasury": {
    "title": "Gruppenpunktekonto",
    "subtitle": "Die gemeinsamen Reserven der Gruppe. Gruppenpunkte fließen anteilig durch bestätigte gute Taten in die Kasse."
  },
  "adminHeroicActions": {
    "reviewUnavailable": {
      "assignment": "Aktuell keine zulässige Prüfzuweisung für dich. Zuweisung, Gruppenbezug und Prüfpausen werden berücksichtigt."
    },
    "tableHero": "Mitglied",
    "keepWarning": "Vergebene Erfahrungspunkte, Vertrauen und Gruppenbelohnungen bleiben erhalten.",
    "reverseWarning": "Gebuchte Erfahrungspunkte, Kategorie-Erfahrungspunkte, Vertrauen und Gruppenbelohnungen werden zurückgerechnet, auch für Gruppenteilnehmer. Bereits ausgegebene Gruppenpunkte können zu einem negativen Gruppenkonto führen.",
    "reviewCategoryHint": "Prüfe die gewählte Kategorie und korrigiere sie bei Bedarf. Die erste Prüfung legt sie für diese Prüfrunde fest; Kategorie-Erfahrungspunkte und Boni richten sich danach.",
    "badge": "Community-Prüfung & Moderation",
    "title": "Community-Prüfung",
    "subtitle": "Prüfe offene gute Taten und bewerte Einsatz und Nachweise der Mitglieder.",
    "antiCheatNotice": "Hinweis: Aus Anti-Cheat-Gründen (Abklingzeiten, Gruppenfilter und Durchmischung) erscheinen manche Einreichungen erst nach der Prüfung anderer guter Taten oder nach Ablauf einer Sperrfrist in der Übersicht.",
    "xpLabel": "Erfahrungspunkte und Basiswerte",
    "searchPlaceholder": "Gute Tat oder Mitglied suchen…",
    "allRanks": "Alle Ränge",
    "allBands": "Alle Erfahrungspunkte-Bänder",
    "rank": "Rang",
    "xpBand": "Erfahrungspunkte-Band",
    "applications": "Bewerbungen für die Community-Prüfung",
    "organizerOkay": "Gruppen-Organisator-Richtlinie bestätigt",
    "organizerMissing": "Gruppen-Organisator-Richtlinie noch nicht bestätigt",
    "heroEstimate": "Einschätzung des Mitglieds:",
    "assessHint": "Passe Zeit und Einsatz, Planung und Abstimmung sowie Erfahrungspunkte-Werte verbindlich an.",
    "baseGroup": "Basis-Erfahrungspunkte (gesamte Gruppe)",
    "base": "Basis-Erfahrungspunkte",
    "categoryGroup": "Kategorie-Erfahrungspunkte (gesamte Gruppe)",
    "guidanceAdmin": "Admin-Prüfung erforderlich (außergewöhnlich oder hohe Erfahrungspunkte)."
  },
  "adminAppeals": {
    "detailIntro": "Prüfe die Begründung und entscheide über eine neue Community-Prüfrunde."
  },
  "quick_heroic_action": {
    "experience_elixir": "Erfahrungsbonus: +25 % Erfahrungspunkte bei Bestätigung."
  },
  "heroicActions": {
    "slots_full_redirect": "Alle Slots sind durch offene Vorhaben oder eine laufende Wartezeit belegt. Unter „Meine Slots“ siehst du, wann wieder ein Slot frei wird.",
    "breakdown": {
      "total": "Gesamt-Erfahrungspunkte",
      "category": "Kategorie-Erfahrungspunkte",
      "guild": "Gruppenbonus",
      "classBonus": "Schwerpunktbonus",
      "groupFormula": "Rechnung: ⌊{{base}} × {{event}} × (1 + {{guild}} % Gruppe + {{party}} % Gruppe)⌋",
      "groupTotal": "Gruppen-Erfahrungspunkte nach Event-, Gruppen- und Gruppenbonus: {{total}}",
      "share": "Anteil vor persönlichen Boni: {{xp}} Erfahrungspunkte ({{percent}} % gemäß Freigabe der Community-Prüfung)",
      "legacyShare": "Anteil vor persönlichen Boni: {{xp}} Erfahrungspunkte bei {{count}} Teilnehmenden",
      "credited": "Persönlich gutgeschrieben: {{xp}} Erfahrungspunkte",
      "missingFactors": "Nicht einzeln rekonstruierbare Event-/Gruppenwirkung und Rundung: {{xp}} Erfahrungspunkte",
      "rounding": "Der Event-Faktor wirkt zuerst. Gruppen-Erfahrungspunkte werden nach den Anteilen mit Restverteilung aufgeteilt; persönliche Boni werden danach angewendet und abgerundet.",
      "legacyFactors": "Bei dieser älteren Einreichung wurden nicht alle Faktoren gespeichert. Die endgültige Gutschrift stammt aus dem Erfahrungspunkte-Konto."
    },
    "categoryXp": "Kategorie-Erfahrungspunkte",
    "eine_reparatur_pro_h": "Eine Reparatur pro gute Tat. Überarbeite die Beschreibung oder reiche einen neuen Nachweis ein. Die Community-Prüfung prüft erneut.",
    "klassenf_higkeit": "Schwerpunktbonus",
    "filterXp": "Erfahrungspunkte-Band",
    "allXpBands": "Alle Erfahrungspunkte-Stufen",
    "sortXpDesc": "Erfahrungspunkte (Höchste zuerst)",
    "sortXpAsc": "Erfahrungspunkte (Niedrigste zuerst)",
    "xpFor": "Erfahrungspunkte für",
    "closeXpBreakdown": "Erfahrungspunkte-Berechnung schließen",
    "showXpBreakdown": "Erfahrungspunkte-Berechnung anzeigen",
    "xpBreakdown": "Erfahrungspunkte-Berechnung",
    "baseXp": "Von der Community-Prüfung festgelegte Basis-Erfahrungspunkte",
    "awardedXp": "Gutgeschriebene Erfahrungspunkte"
  },
  "heroicActionXpGuide": {
    "baseXp": "Basis-Erfahrungspunkte",
    "title": "Erfahrungspunkte-Hilfe und Beispiele",
    "intro": "Jede gute Tat zählt, auch kleine Alltagshilfen. Schätze ein, wie viel Zeit und Einsatz deine Tat erfordert hat und wie viel Planung und Abstimmung nötig waren. Beide Einschätzungen ergeben ein verbindliches Erfahrungspunkte-Band. Die Community-Prüfung prüft deine Angaben und vergibt Basis-Erfahrungspunkte innerhalb dieses Bands. Schwerpunkte- oder Boost-Boni werden danach berechnet.",
    "subtitle": "Orientierung für Zeit und Einsatz, Planung und Abstimmung sowie Erfahrungspunkte-Bänder",
    "estimatedXp": "Ungefähre Erfahrungspunkte",
    "bandOption": "Band {{band}} ({{min}}–{{max}} Erfahrungspunkte)",
    "groupBaseXp": "Basis-Erfahrungspunkte im Gruppenpool",
    "groupIntro": "Gruppenaktionen haben acht eigene Erfahrungspunkte-Bänder mit höheren gemeinsamen Pools. Die Community-Prüfung bewertet den belegten gemeinsamen Einsatz. Die Teilnehmerzahl allein erhöht den Pool nicht. Boni werden auf den Pool angewendet, danach wird er nach den gespeicherten Prozentanteilen verteilt. Einzelaktionen verwenden ihre eigenen sechs Bänder.",
    "mixedBandOption": "Band {{band}} · Einzel {{soloMin}}–{{soloMax}} / Gruppe {{min}}–{{max}} Erfahrungspunkte",
    "groupBandOption": "Gruppenband {{band}} ({{min}}–{{max}} Erfahrungspunkte)"
  },
  "guild_administration": {
    "profile_title": "Gruppen-Stammdaten & Standort",
    "profile_intro": "Passe die offiziellen Stammdaten, das Leitbild und den geografischen Standort eurer Gruppe auf der Weltkarte an.",
    "official_name": "Offizieller Gruppenname",
    "description_label": "Gruppen-Motto & Philosophie / Beschreibung",
    "description_placeholder": "Beschreibe die Ideale, Gute-Taten-Schwerpunkte und die Geschichte deiner Gruppe...",
    "location_label": "Gruppen-Standort auf der Weltkarte",
    "name_required": "Bitte gib einen offiziellen Gruppennamen an.",
    "profile_saved": "Gruppen-Stammdaten & Standort erfolgreich gespeichert!",
    "emblem_title": "Gruppen-Logo-Editor",
    "emblem_settings_title": "Gruppenlogo verwalten",
    "emblem_intro": "Passe das heraldische Gruppenlogo deiner Gruppe an. Das Banner repräsentiert euch im gesamten Königreich und auf Visitenkarten.",
    "emblem_alt": "Gruppenlogo",
    "customize_emblem": "Gruppenlogo anpassen",
    "save_emblem": "Gruppenlogo speichern",
    "emblem_admin_only": "Nur Gruppenleitungen können das Gruppenlogo bearbeiten und speichern.",
    "emblem_saved": "Gruppenlogo erfolgreich geschmiedet.",
    "forge_upgrade_intro": "Den erweiterten Logo-Editor mit zusätzlichen Motiven und Gestaltungsoptionen könnt ihr im Gruppen-Shop freischalten.",
    "theme_title": "Design der Gruppenübersicht & Raumstil",
    "theme_intro": "Wähle ein freigeschaltetes Layout für eure Gruppenübersicht. Kosten und Berechtigungen bleiben gleich.",
    "theme_eyebrow": "Gruppenübersicht · Raumstile",
    "theme_default_description": "Ein übersichtliches Layout für eure Gruppe.",
    "theme_forest": "Natur",
    "theme_celestial": "Sterne",
    "unlock_in_shop": "→ Im Shop freischalten ({{price}} Gruppenpunkte)",
    "theme_saved": "Deine Gruppenübersicht wurde aktualisiert.",
    "applications_intro": "Überprüfe Beitrittsanfragen von Mitgliedern, die eurem Bündnis beitreten möchten.",
    "bans_title": "Gruppen-Sperren & Verbannte Mitglieder ({{count}})",
    "bans_intro": "Gebannte Spieler können dieser Gruppe nicht mehr beitreten. Du kannst Sperren hier jederzeit wieder aufheben.",
    "no_bans": "Keine aktiven Gruppen-Sperren vorhanden.",
    "ban_success": "\"{{name}}\" wurde erfolgreich aus der Gruppe verbannt und gesperrt."
  },
  "guildDetail": {
    "active_adventurers": "{{count}} aktive Mitglieder",
    "einige_wappen_erford": "Einige Gruppenlogos erfordern die",
    "berpr_fe_neue_beitr": "Überprüfe neue Beitrittsanfragen von Mitgliedern.",
    "passe_das_wappen_dei": "Passe das Gruppenlogo deiner Gruppe an. Das Gruppenlogo repräsentiert euch im gesamten Königreich.",
    "gebannte_spieler_k_n": "Gebannte Spieler können dieser Gruppe nicht mehr beitreten. Du kannst Sperren hier jederzeit aufheben.",
    "abenteurer_aus_gilde": "Mitglied aus der Gruppe bannen",
    "gildenhaus_nicht_gef": "Gruppenübersicht nicht gefunden",
    "der_abenteurer_wird": "Mitglied wird sofort aus der Gruppe entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
    "aktuelles_wappen": "Aktuelles Gruppenlogo",
    "zur_ck_zur_gilden_be": "Zurück zur Gruppenübersicht",
    "erweiterte_wappensch": "Erweiterter Logo-Editor",
    "wird_auf_visitenkart": "Wird auf Visitenkarten und in den News angezeigt."
  },
  "adminClassCategoryManager": {
    "keine_klassen_vorhan": "Keine Schwerpunkte vorhanden.",
    "erkl_re_genau_wie_di_placeholder": "Erkläre genau, wie dieser Perk wirkt und auf welche guten Taten, Erfahrungspunkte oder Partnervorteile er sich auswirkt..."
  },
  "gameMechanics": {
    "faire_xp_teilung": "Faire Erfahrungspunkte-Teilung"
  },
  "guildMembersAdmin": {
    "der_abenteurer_wird": "Mitglied wird sofort aus der Gruppe entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
    "es_sind_derzeit_kein": "Es sind derzeit keine Mitglieder für diese Gruppe blockiert.",
    "gesperrte_abenteurer": "Gesperrte Mitglieder",
    "abenteurer_aus_gilde": "Mitglied aus der Gruppe bannen",
    "lade_gesperrte_abent": "Lade gesperrte Mitglieder...",
    "neue_beitrittsanfrag": "Neue Beitrittsanfragen von Mitgliedern erscheinen hier zur Überprüfung."
  },
  "systemEvents": {
    "karma": "Vertrauen",
    "xp_multiplier": "+{{percent}} % Erfahrungspunkte (×{{multiplier}})",
    "base_xp": "★ {{count}} Erfahrungspunkte",
    "cat_xp": "🎖️ {{count}} Kat-Erfahrungspunkte",
    "karma_reward": "👑 {{count}} Vertrauen",
    "base_xp_label": "Basis-Erfahrungspunkte",
    "cat_xp_label": "Kategorie-Erfahrungspunkte",
    "bonus_xp": "+{{percent}} % Event-Erfahrungspunkte."
  },
  "worldMapView": {
    "gilde_betreten": "Gruppe betreten",
    "gildenruhm": "Gruppenruhm",
    "w_hle_eine_gilde_ode": "Wähle eine Gruppe oder einen Partner auf der Karte, um weitere Details zu erfahren.",
    "guilds": "Gruppen",
    "guild_type": "Gruppe"
  },
  "partnerDetail": {
    "adventurer_missing": "Mitglied nicht gefunden.",
    "adventurer_required": "Nur freigeschaltete Mitglieder dürfen Angebote digital einlösen.",
    "how_to_redeem_desc": "Zeige an der Kasse oder beim Service deinen offiziellen Gruppen-QR-Pass vor. Eine Partner:in scannt deinen Code und gewährt dir sofort den Vorteil!"
  },
  "heroicOverview": {
    "karma": "Vertrauen",
    "total_xp": "Gesamt-Erfahrungspunkte"
  },
  "guild_overview": {
    "renown_and_stage": "Gruppenruhm & Ausbaustufe",
    "renown_description": "Dauerhaft gesammelte Basis-Erfahrungspunkte aus den gutgeschriebenen guten Taten eurer Gruppe.",
    "next_stage_from": "{{detail}} ab {{min}} Ansehen",
    "gildex_earned": "Gruppenpunkte verdient",
    "balance_suffix": "Gruppenpunkte-Guthaben: {{balance}}.",
    "guild_members": "Gruppenmitglieder",
    "ep_boost_title": "zusätzlicher Erfahrungspunkte-Boost",
    "ep_boost_active": "+{{percent}}% Erfahrungspunkte-Bonus aktiv",
    "ep_boost_inactive": "Kein Erfahrungspunkte-Bonus aktiv",
    "ep_boost_status_active": "Erfahrungspunkte-Bonus aktiv",
    "ep_boost_hint": "Schaltet Stufe 1 frei und sammelt als Gruppe bei guten Taten mehr Erfahrungspunkte.",
    "ep_boost_desc": "Der zusätzliche Brunnen verstärkt die Erfahrungspunkte aller Gruppenmitglieder bei allen abgeschlossenen guten Taten um {{percent}}%.",
    "ep_boost_upgrade": "Im Gruppen-Shop aufwerten →",
    "ep_boost_activate": "Jetzt im Gruppen-Shop freischalten →",
    "ep_boost_max": "Maximale Erfahrungspunkte-Boost-Stufe erreicht (+5%)"
  },
  "guild_hall_stage": {
    "aria_label": "Gruppenübersicht",
    "bg_alt": "Gruppenübersicht Hintergrund",
    "renown_suffix": "({{renown}} Ansehen)",
    "forest_theme_tooltip": "Natur",
    "celestial_theme_tooltip": "Sterne",
    "banner_aria": "Gruppenlogo & Banner",
    "banner_sprite_alt": "Gruppenbanner",
    "banner_crest_alt": "Gruppenlogo",
    "default_guild_name": "Gruppenlogo",
    "profile_wall_aria": "Profilwand: Gruppenmitglieder",
    "trophy_shelf_locked": "Gemeinsame Erfolge (Gruppen-Shop)",
    "fame_monument_aria": "Ansehensmonument & Gute Taten",
    "fame_monument_sprite_alt": "Ansehensmonument",
    "fame_monument_title": "Ansehensmonument",
    "chest_aria": "Gruppenkasse (Punktekonto)",
    "chest_title": "Punktekonto (Gruppenpunkte & Tresor)",
    "shop_stall_aria": "Gruppen-Kaufmannsstand",
    "shop_stall_title": "Gruppen-Katalog & Freischaltungen",
    "stammtisch_aria": "Gruppen-Stammtisch (Chat)",
    "stammtisch_unlocked": "Gruppen-Stammtisch",
    "stammtisch_locked": "Gruppen-Stammtisch (Gruppen-Shop)",
    "group_table_unlocked": "Gruppen-Konferenztisch (Gruppen-Aktionen)",
    "group_table_locked": "Gruppenaktionstisch (Gruppen-Shop)",
    "admin_desk_aria": "Gruppenleiter-Schreibtisch (Verwaltung)",
    "admin_desk_unlocked": "Verwaltungspult (Gruppenleitung)",
    "admin_desk_locked": "Gruppenleiter-Pult (Gruppen-Shop)",
    "anvil_aria": "Gruppenlogo-Amboss (Gruppendesign)",
    "anvil_sprite_alt": "Gruppenlogo-Amboss",
    "anvil_unlocked": "Gruppenlogo-Amboss (Emblem-Builder)",
    "anvil_locked": "Gruppenlogo-Amboss (Gruppen-Shop)",
    "fountain_aria": "Erfahrungspunkte-Brunnen",
    "fountain_sprite_alt": "Erfahrungspunkte-Brunnen",
    "fountain_unlocked": "Erfahrungspunkte-Brunnen (+{{percent}}% Erfahrungspunkte-Boost)",
    "fountain_locked": "Erfahrungspunkte-Brunnen (Gruppen-Shop)"
  },
  "system_admin": {
    "adventurer_view": "Mitglied-Ansicht"
  },
  "partner_portal": {
    "brand_title": "Portal"
  },
  "partner_redemptions": {
    "subtitle": "Übersicht aller durchgeführten Einlösungen deiner Angebote durch Mitglieder (Vor Ort und Remote/Digital).",
    "stat_adventurers": "Erreichte Mitglieder",
    "search_placeholder": "Mitglied, Angebot, Gruppe oder Code suchen …",
    "no_redemptions_desc": "Sobald Mitglieder deine Angebote vor Ort über den QR-Pass oder digital einlösen, erscheinen sie in dieser Liste."
  },
  "partner_profile": {
    "bio_placeholder": "Beschreibe dein Unternehmen, dein Angebot oder Besonderheiten für Mitglieder auf der Weltkarte …"
  },
  "audit_ui": {
    "room": {
      "news": {
        "description": "Neuigkeiten aus deiner Gruppe"
      },
      "roster": {
        "description": "Die Menschen hinter deiner Gruppe"
      },
      "trophies": {
        "title": "Gemeinsame Erfolge"
      },
      "design": {
        "title": "Design der Gruppenübersicht"
      },
      "settings": {
        "description": "Mitglieder und Gruppeneinstellungen verwalten"
      },
      "treasury": {
        "title": "Punktekonto",
        "description": "Euer gemeinsamer Gruppenschatz"
      },
      "forge": {
        "title": "Gruppenlogo gestalten",
        "description": "Euer Gruppenlogo und seine Gestaltung"
      },
      "stats": {
        "title": "Ansehen & Statistik",
        "description": "Euren Gruppenruhm und Fortschritt entdecken"
      }
    },
    "all_guilds": "Alle Gruppen",
    "view_hall_image": "Ganzes Bild der Gruppenübersicht anzeigen",
    "emblem": "Gruppenlogo",
    "welcome": "Willkommen in deiner Gruppe",
    "your_guild": "Deine Gruppe",
    "home": "Gruppenheim",
    "updates": "Aktuelles aus der Gruppe",
    "news_hint": "Hier erscheinen die Neuigkeiten eurer Gruppe.",
    "treasure": "Punktekonto",
    "rooms": "Deine Gruppenbereiche",
    "unlock_shop": "Im Gruppen-Shop freischalten",
    "shop": "Der Gruppenladen",
    "shop_heading": "Eure Gruppe weiterentwickeln",
    "tools": "Gruppenwerkzeuge",
    "stats": "Ansehen & Statistiken",
    "boost_discover": "Erfahrungspunkte-Bonus entdecken",
    "forge": "Logo-Editor",
    "boost": "Erfahrungspunkte-Bonus +{{percent}} %",
    "theme_alt": "{{theme}} mit den angrenzenden Gruppenbereichen",
    "themes": {
      "default": "Klar",
      "forest": "Natur",
      "celestial": "Sterne"
    },
    "karma_designation": "Vertrauens-Bezeichnung",
    "guild": "Gruppe",
    "no_guild": "Noch keine Gruppe",
    "renown": [
      "Gründung",
      "Anerkannt",
      "Angesehen",
      "Berühmt",
      "Legendär"
    ]
  },
  "categories_guide": {
    "intro": "Jede gute Tat gehört zu einem Bereich. Dort sammelst du zusätzlich zu deinen Gesamt-Erfahrungspunkte eigene Kategorie-Erfahrungspunkte. Wähle die Kategorie, die am besten zu deinem tatsächlichen Beitrag passt.",
    "examples_link": "Beispiele und Erfahrungspunkte ansehen"
  },
  "category_showcase": {
    "xp_caption": "Gute Taten. Eigene Kategorie-Erfahrungspunkte."
  },
  "landing_classes": {
    "heading_title": "Finde deinen Schwerpunkt",
    "heading_subtitle": "Zehn Bereiche, in denen deine Unterstützung zählt.",
    "picker_label": "Schwerpunkt für die Vorschau wählen",
    "loading_perks": "Schwerpunkt-Perks werden geladen …",
    "no_perks": "Für diesen Schwerpunkt sind aktuell keine Perks hinterlegt.",
    "selected_class": "Ausgewählter Schwerpunkt",
    "explore_class": "Schwerpunkt entdecken",
    "no_classes": "Aktuell sind keine Schwerpunkte verfügbar.",
    "choose_class_title": "Wähle deinen Schwerpunkt",
    "choose_class_hint": "Klicke auf ein Emblem oder den Button, um deinen Schwerpunkt festzulegen."
  },
  "good_deed_examples": {
    "intro": "Diese Beispiele zeigen, welcher Aufwand ungefähr in welche Erfahrungspunkte-Spanne fällt. Die Community-Prüfung bewertet deine tatsächliche Tat und den Nachweis; die Zahlen sind Richtwerte.",
    "table_label": "Erfahrungspunkte-Beispiele",
    "xp_title": "Wie werden Erfahrungspunkte bestimmt?",
    "xp_intro": "Entscheidend sind Zeit, Belastung und Verantwortung sowie Planung, Abstimmung und Beteiligte. Bei Spenden zählt dein eigener Einsatz, nicht der Geld- oder Warenwert. Erfahrungspunkte gibt es erst nach der endgültigen Bestätigung."
  },
  "guildHeroicActions": {
    "statuses": {
      "PendingReview": "Bei der Community-Prüfung"
    },
    "chat": {
      "submitted": "[GUTE TAT] {{title}} wurde mit {{count}} bestätigten Teilnehmenden bei der Community-Prüfung eingereicht.",
      "evidenceUploaded": "[GUTE TAT] {{title}}: Der verschlüsselte Nachweis wurde hochgeladen und die gute Tat an die Community-Prüfung übergeben."
    },
    "adminOnly": "Nur Gruppen-Admins können Gruppenaktionen ausrufen.",
    "intro": "Gruppenmitglieder organisieren sich gemeinsam. Der Organisator verteilt die bestätigten Erfahrungspunkte; die Community-Prüfung prüft die Verteilung.",
    "locked": "Gruppenaktionen sind noch nicht freigeschaltet. Ein Gruppen-Admin kann sie im Gruppenpunkte-Shop freischalten.",
    "split": "Basis-Erfahrungspunkte, danach gemäß Verteilung des Organisators",
    "allocationTitle": "Erfahrungspunkte-Verteilung",
    "submit": "Bei der Community-Prüfung einreichen",
    "resubmit": "Erneut bei der Community-Prüfung einreichen",
    "allocationFor": "Erfahrungspunkte-Anteil für {{name}}",
    "allocationBonuses": "Diese Anteile gelten vor persönlichen Boni. Ganze Erfahrungspunkte werden mit Restverteilung gerundet; dadurch ist eine Abweichung von weniger als 1 Erfahrungspunkt möglich.",
    "allocationReviewTitle": "Erfahrungspunkte-Verteilung des Organisators",
    "allocationApprove": "Hast du die Erfahrungspunkte-Verteilung des Organisators geprüft und gibst sie frei?",
    "guideLink": "Ablauf und Erfahrungspunkte einer Gruppenaktion erklären"
  },
  "groupActionGuide": {
    "eyebrow": "Leitfaden für Gruppenleitungen",
    "intro": "Anna organisiert eine Müllsammelaktion mit Ben, Clara, David und Eva. Hier siehst du den Weg von der Einladung bis zur Auszahlung – einschließlich Abmeldungen, Community-Prüfung und Erfahrungspunkte-Boni.",
    "navigation": [
      "Ablauf",
      "Nichterscheinen",
      "Erfahrungspunkte & Buffs",
      "Entscheidungen & Abschluss"
    ],
    "steps": [
      {
        "title": "Aktion ankündigen",
        "text": "Die Gruppe benötigt die Freischaltung Gruppenaktionen. Über „Gute Tat ausrufen“ öffnest du eine eigene Formularseite. Dort legst du Titel, Beschreibung, Kategorie, Schwierigkeit, Komplexität und Termin fest; Anmeldeschluss und Teilnehmerlimit sind optional. Bestätige Freiwilligkeit, nicht kommerziellen Zweck, sichere Organisation und dass keine bezahlte Arbeit ersetzt wird. Die Mitglieder werden benachrichtigt."
      },
      {
        "title": "Einladen und selbst anmelden",
        "text": "Einladungen melden niemanden automatisch an. Alle fünf melden sich selbst an, auch Anna, wenn sie Erfahrungspunkte erhalten möchte. Die Anmeldung benötigt und belegt einen freien Gute-Tat-Slot. Solange die Aktion nicht eingereicht ist, können Personen sich abmelden und die Gruppenleitung kann die Aktion absagen. Bei Absage werden die Einladungsbenachrichtigungen dieser Aktion entfernt; angemeldete Mitglieder erhalten eine Absagebenachrichtigung."
      },
      {
        "title": "Teilnehmen und selbst bestätigen",
        "text": "Ab dem geplanten Termin bestätigt jede Person ihre tatsächliche Teilnahme selbst. Es gibt keine stellvertretende oder gegenseitige Bestätigung. Warte vor dem Einreichen auf alle tatsächlichen Teilnehmer: Mindestens zwei Bestätigungen sind notwendig; nur angemeldete Personen werden beim Einreichen als zurückgezogen behandelt."
      },
      {
        "title": "100 % in ganzen Prozent verteilen",
        "text": "Anna verteilt beispielsweise 40 / 25 / 15 / 10 / 10 %. Jede Person darf höchstens 50 % erhalten, Anna eingeschlossen. Nur bestätigte Personen zählen. 0 % ist erlaubt, mindestens zwei Personen benötigen einen positiven Anteil. Nachkommastellen sind nicht erlaubt. Bei mehr als 100 Personen müssen einige 0 % erhalten. Eine zusätzliche Zustimmung der Teilnehmer zur Verteilung ist nicht vorgesehen."
      },
      {
        "title": "Gemeinsamen Nachweis hochladen",
        "text": "Wähle ein Bild, ein PDF oder ein MP4 und bestätige die Datenschutzhinweise. Zuerst wird die Einreichung gespeichert, dann der Nachweis hochgeladen. Bei einem Uploadfehler kannst du den Upload nachholen. Erst danach geht die Aktion an die Community-Prüfung. Die Anteile sind während der Prüfung gesperrt."
      },
      {
        "title": "Community-Prüfung entscheidet",
        "text": "Die Community-Prüfung prüft Nachweis und Verteilung. Die erste Prüfung legt Kategorie, Schwierigkeit, Komplexität sowie Basis- und Kategorie-Erfahrungspunkte fest. Jede Zustimmung zur Aktion muss die Verteilung ausdrücklich bestätigen. Eigene Aktionen und für reguläre Moderatoren Aktionen der eigenen Gruppe sind ausgeschlossen. Bei Freigabe werden die Belohnungen verbucht."
      }
    ],
    "absence": [
      {
        "title": "Eva meldet sich ab oder bestätigt nicht",
        "text": "Eva erhält keine Erfahrungspunkte und liefert keinen Gruppenbuff. Bleibt sie nur angemeldet, wird sie bei der Einreichung automatisch zurückgezogen. Anna verteilt 100 % auf die übrigen bestätigten Personen. Auch wer tatsächlich dabei war, aber die Bestätigung vergessen hat, wird so ausgeschlossen."
      },
      {
        "title": "Eva bestätigt fälschlich ihre Teilnahme",
        "text": "Einen eigenen Button zum Melden von Nichterscheinen, einen Anwesenheitsnachweis oder eine automatische Strafe gibt es derzeit nicht. Anna kann vor der Einreichung 0 % zuweisen und den Sachverhalt in der Beschreibung erläutern. Eva bleibt technisch bestätigt, erhält aber weder Erfahrungspunkte noch Vertrauen und trägt keinen Gruppenbuff bei. Nach Einreichung ist für eine Änderung eine Rückgabe durch die Community-Prüfung nötig."
      },
      {
        "title": "Was die Prozentregel nicht prüft",
        "text": "Ein positiver Anteil ab 1 % aktiviert den vollständigen passenden Gruppenbuff der Person. Das System prüft keine Mindestleistung. Die tatsächlichen Beiträge müssen über Beschreibung, Nachweis und Community-Prüfung nachvollziehbar sein."
      }
    ],
    "xpTitle": "So wirken Erfahrungspunkte und Buffs",
    "xpIntro": "Zuerst wird ein gemeinsamer Erfahrungspunkte-Pool berechnet, dann nach den gespeicherten Anteilen verteilt. Persönliche Boni wirken anschließend auf den eigenen Anteil. Gesamt-Erfahrungspunkte und Kategorie-Erfahrungspunkte werden getrennt berechnet.",
    "formula": "Gruppenpool = abrunden(Basis-Erfahrungspunkte × Eventfaktor × (1 + Gruppenausbau + Gruppenbuff))",
    "example": "Beispiel in Gruppenband 5: Die Community-Prüfung setzt 2.000 Basis-Erfahrungspunkte und 2.000 Kategorie-Erfahrungspunkte an. Kein Eventbonus (Faktor 1), +5 % Gruppenausbau, +10 % durch Ben als Initiator und +10 % durch Claras Gruppen-Mentor Rang 2 ergeben je 2.500 Erfahrungspunkte im Pool. Alle fünf haben zusätzlich den persönlichen Gruppenbonus von 5 %. Anna ist Naturfreund und bekommt in Umwelt & Natur weitere 20 %. David ist Forscher und bekommt hier weitere 10 % Kategorie-Erfahrungspunkte. Weitere Vorteile nehmen wir nicht an.",
    "columns": [
      "Person",
      "Anteil",
      "Pool-Anteil",
      "Gesamt-Erfahrungspunkte",
      "Kategorie-Erfahrungspunkte"
    ],
    "rows": [
      [
        "Anna · Naturfreund",
        "40 %",
        "1000",
        "1250",
        "1250"
      ],
      [
        "Ben · Initiator",
        "25 %",
        "625",
        "656",
        "656"
      ],
      [
        "Clara",
        "15 %",
        "375",
        "393",
        "393"
      ],
      [
        "David · Forscher",
        "10 %",
        "250",
        "262",
        "287"
      ],
      [
        "Eva",
        "10 %",
        "250",
        "262",
        "262"
      ],
      [
        "Summe",
        "100 %",
        "2500",
        "2823",
        "2848"
      ]
    ],
    "rounding": "Die Pool-Aufteilung verteilt Rest-Erfahrungspunkte deterministisch, damit keine Pool-Erfahrungspunkte verloren gehen. Ein Anteil kann durch Ganzzahlrundung um weniger als 1 Erfahrungspunkt vom Prozentwert abweichen. Persönliche Erfahrungspunkte werden danach abgerundet.",
    "buffs": [
      "Erfahrungspunkte-Events multiplizieren die Basis-Erfahrungspunkte. Ohne aktives Event ist der Faktor 1.",
      "Gruppenausbau: Nur die höchste freigeschaltete Stufe zählt (+1 bis +5 %). Zusätzlich gibt die Gruppenmitgliedschaft persönlich +5 %.",
      "Freizeit & Begegnung: standardmäßig +10 % für die Gruppe. Mehrere Initiatoren stapeln diesen Schwerpunktbonus nicht; der stärkste Schwerpunkt-Gruppenbonus zählt einmal.",
      "Gruppen-Mentor: +5 / +10 / +15 % je Rang. Beiträge mehrerer Personen werden addiert. Schwerpunkt-Gruppenbonus und Gruppen-Vorteile zusammen sind auf +50 % begrenzt.",
      "Nur bestätigte Personen mit positivem Erfahrungspunkte-Anteil liefern Gruppenbuffs. Ein Buff wird nicht mit dem Prozentanteil seines Besitzers verkleinert.",
      "Passende Schwerpunktboni geben standardmäßig +20 % Gesamt- und Kategorie-Erfahrungspunkte. Persönliche Erfahrungspunkte-Boni werden addiert; reine Kategorie-Boni erhöhen nur Kategorie-Erfahrungspunkte.",
      "Das wöchentliche Erfahrungsbonus gilt nur für Einzelaktionen. Zeitlich begrenzte persönliche Buffs werden für diese Gruppenbelohnung nicht berücksichtigt."
    ],
    "buffTiming": "Schwerpunkt- und Vorteileffekte werden bei Einreichung pro Person gespeichert; bei überarbeiteter Neueinreichung werden sie erneut erfasst. Eventfaktor und Gruppenausbau werden in der ersten Community-Prüfung festgehalten. Spätere Änderungen erhöhen die laufende Prüfung nicht nachträglich.",
    "outcomes": [
      {
        "title": "Rückgabe zur Überarbeitung",
        "text": "Anna kann Beschreibung und Verteilung überarbeiten und mit einem Nachweis erneut einreichen. Eine neue Prüfrunde beginnt; alte Freigaben gelten dafür nicht. Die Community-Prüfung ändert die Anteile nicht selbst. Während der Rückgabe ist die Aktion kein offener Slot."
      },
      {
        "title": "Ablehnung und Einspruch",
        "text": "Bei Ablehnung gibt es keine Belohnung. Einreicher oder bestätigte Teilnehmer können begründet Einspruch einlegen, standardmäßig einmal innerhalb von 30 Tagen und mit dem ursprünglichen Nachweis. Ein unabhängiger Systemadmin entscheidet. Ein genehmigter Einspruch eröffnet eine neue Community-Prüfrunde, er zahlt noch keine Erfahrungspunkte aus."
      },
      {
        "title": "Anzahl der Prüfungen",
        "text": "Standardmäßig genügt bis 150 Gruppen-Erfahrungspunkte eine Prüfung, bis 500 sind zwei nötig und darüber drei. Ab 500 muss eine Admin-Prüfung enthalten sein. Bei Stimmengleichstand folgt eine weitere Prüfung."
      },
      {
        "title": "Vertrauen, Gruppenpunkte und Benachrichtigungen",
        "text": "Positive Anteilsempfänger erhalten grundsätzlich mindestens +1 Vertrauen, gegebenenfalls mit persönlichen Boni. Von der Community-Prüfung vergebene Ehre wird gleichmäßig unter positiven Anteilsempfängern verteilt. 0 % gibt weder Erfahrungspunkte noch Vertrauen. Die Gruppe erhält einmal Gruppenpunkte aus den Basis-Erfahrungspunkten, standardmäßig 10 %: im Beispiel 200 Gruppenpunkte. Alle bestätigten Personen werden über das Ergebnis benachrichtigt, auch bei 0 %."
      },
      {
        "title": "Slot und Wartezeit",
        "text": "Der Gruppen-Wartezeit läuft ab Anmeldung, standardmäßig 24 Stunden, gegebenenfalls durch Effekte verkürzt. Solange die Aktion offen ist, bleibt der Slot auch nach Ablauf dieses Timers belegt. Die Auszahlung startet keinen neuen Timer. Abmeldung, Absage oder Ablehnung lösen die offene Reservierung auf."
      },
      {
        "title": "Gruppenaustritt während der Aktion",
        "text": "Ein Austritt oder Ausschluss beendet die aktive Teilnahme. Bleiben bei einer eingereichten Aktion weniger als zwei bestätigte Personen, wird sie abgesagt. Bei weiteren verbleibenden Personen wird eine dadurch ungültige Erfahrungspunkte-Verteilung nicht automatisch umgerechnet; sie muss vor einer Freigabe geklärt und gegebenenfalls nach Rückgabe korrigiert werden."
      }
    ],
    "defaults": "Die Zahlen erklären den aktuellen Standard. Admins können Prüfgrenzen, Wartezeiten, Gruppenpunkte-Raten und Schwerpunkteffekte konfigurieren. Bereits gespeicherte ältere Verteilungen bleiben für Auszahlung und Neuberechnung erhalten; neue oder geänderte Verteilungen verwenden ganze Prozent.",
    "assessmentBands": "Die beiden Skalen bestimmen die Bandnummer. Umfangreicher Gemeinschaftseinsatz mit „Viel geplant“ oder „Sehr hoch“ mit mehrstufiger Organisation ergibt Gruppenband 7 (standardmäßig 4.000–6.000 Basis-Erfahrungspunkte). Beide neuen höchsten Stufen ergeben Gruppenband 8 (6.000–10.000). Auch Gruppenbänder 1–6 haben eigene, höhere Pools. Alle Gruppenwerte sind unabhängig von Einzelaktionen konfigurierbar.",
    "assessmentExample": "Beispiel: Mehrere Teams werten eine Gemeinschaftsfläche an mehreren Arbeitstagen auf. Materialbeschaffung, Freigaben, Arbeitsphasen und Übergaben zwischen beteiligten Stellen müssen nachweisbar koordiniert werden. Beide neuen Stufen können passen; die Community-Prüfung entscheidet anhand des tatsächlichen Einsatzes."
  },
  "systemCopy": {
    "16885658fbb9": " (Gruppenpunkte)",
    "b5451aaa13ba": "Mitglied",
    "d658d199540c": "0 Erfahrungspunkte",
    "42e2aa5470e7": " Erfahrungspunkte",
    "9717eb352337": "Erfahrungsbonus",
    "3ba62c293ab6": "Erhalte einmal pro Woche 25 % mehr Erfahrungspunkte für eine einzelne gute Tat.",
    "450864ab665b": "Einmal pro Woche 25 % mehr Erfahrungspunkte für eine Einzeltat.",
    "b6fbffaeb18a": " group-shop",
    "5b3e5f590e60": "Gruppenpunkte",
    "356db5eb31f6": " Gruppenpunkte",
    "198fb678c812": "Gruppenstatistik",
    "dbbcc055fb26": "Bestätigte gute Taten",
    "5b11fe2f04f5": "Gruppenpunkte verdient",
    "32d823725418": "Gruppenpunkte verdient",
    "15a3179e1e7c": "gute Taten gegenüber dem vorherigen gleich langen Zeitraum:",
    "bae279e8bf55": "Gezählt ab Bestätigung, Zeitgrenzen in UTC. Historische Leistungen bleiben bei der damaligen Gruppe.",
    "eda3a54706dc": "Gezählt ab Bestätigung, Zeitgrenzen in UTC. Historische Leistungen bleiben bei der damaligen Gruppe.",
    "84283337e247": "gute Taten im Zeitverlauf",
    "71bcfe99e01b": "In diesem Zeitraum wurden noch keine guten Taten bestätigt.",
    "7bd7d6d2efe7": "Aktive Mitglieder im Verhältnis zur gesamten Gruppe",
    "b5cacdba5528": "Aktive Mitglieder im Verhältnis zur gesamten Gruppe",
    "5f9d50483c1f": "Aktiv: mindestens eine bestätigte Einzelaktion für die Gruppe oder Teilnahme an einer bestätigten Gruppenaktion. Gruppenteilnahmen zählen je Aktion, auch von ehemaligen Mitgliedern.",
    "4c6cf7cc1111": "Aktiv: mindestens eine bestätigte Einzelaktion für die Gruppe oder Teilnahme an einer bestätigten Gruppenaktion. Gruppenteilnahmen zählen je Aktion, auch von ehemaligen Mitgliedern.",
    "238c6eef4ba3": "Mit eurer ersten bestätigten guten Tat erscheint hier eure Wirkung nach Kategorien.",
    "3eb20d7dca1d": "Jede gute Tat zählt einmal, unabhängig von ihrer Teilnehmerzahl.",
    "325ba8c1e5d9": "Gruppenpunkte & Ausbau",
    "f4e4094a94ea": "Gruppenpunkte & Ausbau",
    "90d3ccca50df": "Gruppenpunkte-Einnahmen und Ausgaben im gewählten Zeitraum",
    "ee36e9ddce32": "Gruppenpunkte-Einnahmen und Ausgaben im gewählten Zeitraum",
    "2f1d49da1e23": "Direkt beigetragene Gruppenpunkte",
    "06097c96531f": "Direkt beigetragene Gruppenpunkte",
    "4d7fdae14b17": "Gruppenbelohnungen gehören der Gruppe und werden hier nicht auf einzelne Mitglieder aufgeteilt.",
    "fd5c00369a49": "Gruppenbelohnungen gehören der Gruppe und werden hier nicht auf einzelne Mitglieder aufgeteilt.",
    "3e637b9d2de6": "Schaltet den Bereich „Gemeinsame Erfolge“ im Gruppen-Shop frei, um diese Galerie zu öffnen.",
    "982a1365d123": "Schaltet den Bereich „Gemeinsame Erfolge“ im Gruppen-Shop frei, um diese Galerie zu öffnen.",
    "9cb479db5d4b": "Vermächtnis der Gruppe",
    "73d8a14f8596": "Vermächtnis der Gruppe",
    "dc596278d9f5": "Eine dauerhafte Übersicht der bestätigten guten Taten der Gruppe und der Mitglieder, die sie gemeinsam vollbracht haben.",
    "ec8d38bd7fe7": "Lade die Erfolge der Gruppe…",
    "80572bae1749": "Lade die Erfolge der Gruppe…",
    "f5edf45aeade": "Schaltet Gruppenaktionen im Gruppen-Shop frei, um gemeinsame Erfolge zu schaffen.",
    "230b5c30d1bf": "Schaltet Gruppenaktionen im Gruppen-Shop frei, um gemeinsame Erfolge zu schaffen.",
    "9efd79edc63b": "Gruppenlogo gestalten",
    "6722387741d7": "Gruppenlogo-Baukasten (Elemente)",
    "b4b39cdd92fe": "Logo-Editor Freigeschaltet",
    "2e83774788fc": "Zufällige Gruppenlogokombination",
    "3f12c55949e4": "Gruppenlogo Live-Vorschau",
    "2ffc7869e9b2": "Heraldisches Gruppenlogo",
    "3d87aefea2a1": "Logo-Editor-Vorschau",
    "419dedf5e19c": "Dieses Logo nutzt erweiterte Gestaltungselemente. Schalte den erweiterten Logo-Editor im Gruppenshop mit Gruppenpunkten frei, um es zu verwenden.",
    "584aea7f9abe": "Dieses Gruppenlogo nutzt exklusive Schmiede-Elemente. Schalte den \"Erweiterten Logo-Editor\" im Gruppen-Shop mit Gruppenpunkten frei, um es dauerhaft zu speichern.",
    "831cefa91ceb": "Punktekonto öffnen",
    "0122936e8034": "Zum Gruppenpunktekonto",
    "c36f48b7d236": "Klassische Standard-Gruppenlogos",
    "d2b13ba3aa87": "Wähle eine bewährte Standard-Kombination oder wechsle zum Gruppenlogo-Baukasten für individuelle Elemente.",
    "2f03025fd913": "In der Vorschau ziehen oder die Regler verwenden. Änderungen werden im Gruppenlogo gespeichert.",
    "2dd43870a02b": "Krone, Ritterhelm, Flamme oder Zinnen auf dem Gruppenlogo:",
    "111aabea36e8": "Unterer Logoabschluss, Gruppenbanner oder Schmuckanhänger:",
    "0abdafe40412": "Unterer Gruppenlogoabschluss, Gruppen-Banner oder Quaste:",
    "c6c2f4224b32": "Wähle den metallischen Glanz und die Farbtönung des Gruppenlogos:",
    "f1e9205cbb92": "Logo-Editor",
    "168aad3e9812": "Erfahrungspunkte",
    "a9127cc07e92": "Erfahrungspunkte-Hilfe und Beispiele",
    "6a389d6c728d": " Vertrauen",
    "6b2f2ecdd84a": " world-trust--stages",
    "eeafe73f02c8": "Höchste Erfahrungspunkte",
    "3b3f1e54984f": "Niedrigste Erfahrungspunkte",
    "f0a96bd6bf15": "Gruppenleitung",
    "8bc9c6dd8644": " % Erfahrungspunkte",
    "687dfd0ceeee": "Gruppe:",
    "e3e062929a2f": "Das Gruppenlogo konnte bei der Gruppengründung nicht übernommen werden.",
    "31ba47f1fae3": "News",
    "08db035d1806": "Gruppenruhm und Aktivität sind derzeit nicht verfügbar.",
    "845d8127c1b4": "Gruppenruhm und Aktivität konnten nicht geladen werden.",
    "a0a2ab9585a4": "Gruppenübersicht konnte nicht geladen werden.",
    "222a24fd9aa5": "Gruppen-Neuigkeiten konnten nicht geladen werden.",
    "1c07813d09ea": "Gruppenchat konnte nicht geladen werden.",
    "516773403e48": "Die angeforderte Gruppe existiert nicht.",
    "21e1aeea2c1b": "Gruppenverwaltung & Einstellungen",
    "f933fee4b73b": "Gruppenruhm & Statistiken",
    "8e21174aef60": "Erfordert die Freischaltung für weitere Gruppenleitungen im Gruppen-Shop",
    "867d4690e877": "Aus Gruppe entfernen (Kick)",
    "5e0664b086b3": "Dauerhaft aus Gruppe bannen",
    "ee84b83e2a24": "Du kannst nur einer Gruppe gleichzeitig angehören.",
    "e47bab3c5826": "Erfahrungsbonus: +25 % Gesamt- und Kategorie-Erfahrungspunkte bei Bestätigung, ohne Erfahrungspunkte-Kosten.",
    "a9096aac522c": "Gruppenwelt",
    "ab83d1ff771b": "Vertrauens-Score",
    "55681e642a13": "Die Neuigkeiten konnten nicht geladen werden.",
    "00dc19d908f2": "Fehler beim Laden der Schwerpunktdaten.",
    "ccdf9223f7db": " neuen Schwerpunkt",
    "8de641bae922": " Schwerpunkte & Perks (",
    "504823c82e3b": "Schwerpunkt bearbeiten",
    "e6ee49712127": "Schwerpunkt bearbeiten",
    "28b620216833": "Neuen Schwerpunkt anlegen",
    "a05731e81733": "Rolle / Schwerpunkttyp",
    "c58be06c1a93": "Schwerpunkt-Perk bearbeiten",
    "eff481858079": "Gesamt- und Kategorie-Erfahrungspunkte-Bonus",
    "90e7928d0517": "Party-Buff (Gruppen-Erfahrungspunkte)",
    "0f154384cef7": "Ehren-Vertrauen Bonus (+1 Vertrauen)",
    "11c40a51d425": "Vertrauens-Erholung bei negativem Vertrauen",
    "124911b8368c": "Kategorie-Erfahrungspunkte außerhalb der Zielkategorie",
    "db729f7363ab": "Erfahrungsbonus (wöchentlich)",
    "031b655d8aaa": "Erholungs-Vertrauen bis 0",
    "11fc673ba9d9": "Kategorie-Erfahrungspunkte-Bonus",
    "7558dba0c23d": "Gruppenpunkte-Einzahlungsbonus",
    "8d7a465d4068": "Gruppen-Vertrauens-Bonus",
    "70fddef742f8": "Wirkungswert (z.B. 0.20 = +20 %, 1 = +1 Slot/Vertrauen)",
    "63f8d339cf42": "Moderation der Community-Prüfung",
    "54dcaca4c076": "Community-Prüfung (",
    "75deb356299a": "Gruppen (",
    "633ba960808f": "Zur Community-Prüfung",
    "c6d1fc947dc9": "In der Community-Prüfung prüfen",
    "c466734f5af1": "Erfahrungspunkte ×",
    "10c26d79140f": "Erfahrungspunkte-Vorschau konnte nicht geladen werden.",
    "8118de5cc29c": "Erfahrungspunkte wurden neu berechnet und die Differenz gebucht.",
    "c8db42d0bd0d": "Erfahrungspunkte konnten nicht neu berechnet werden.",
    "6f14360d1a0d": "Einstufung & Erfahrungspunkte-Vergabe",
    "3d62c442615b": "Passe Schwierigkeit und Komplexität an, um das verbindliche Erfahrungspunkte-Band festzulegen.",
    "1f7c933aceb6": "Basis-Erfahrungspunkte (Gruppe)",
    "26b475ca7301": "Kategorie-Erfahrungspunkte (Gruppe)",
    "a73feda6e2f7": " Erfahrungspunkte.",
    "c65a3b3858ce": " Erfahrungspunkte neu berechnen",
    "5d35f4fca941": "Gesamt-Erfahrungspunkte:",
    "cb874e449969": " · Kategorie-Erfahrungspunkte:",
    "b35858b78ad4": " Erfahrungspunkte, Kategorie",
    "c23e3acfe229": "Erfahrungspunkte-Hilfe",
    "78b14b08dc14": "Gute Tat oder Mitglied…",
    "1443b9f2211c": "Alle Erfahrungspunkte-Bänder",
    "1698e4ae6293": "z. B. Café Miteinander",
    "a677958fe6cc": "community-cafe",
    "e00e689f3fc3": "info@example.org",
    "0e6ec4da3067": "Genehmigte Bewerber erscheinen hier als aktive Community-Prüfungsmoderatoren.",
    "f4a2115ad657": " Erfahrungspunkte /",
    "21591951cece": " Erfahrungspunkte)",
    "a190c9987e71": " Erfahrungspunkte ·",
    "e166da59b506": "Mitglied (D)",
    "4c99fbbb2a76": "Beschreibe dein Angebot und wie Mitglieder es einlösen können (z.B. Zeige deinen Gruppenpass an der Kasse oder nutze den Online-Code)...",
    "3937a00a22e5": "Standard: Für alle Mitglieder offen (ab Rang F)",
    "c7c3aa207e26": "Mindest-Gesamt-Erfahrungspunkte (optional)",
    "b001b3bb128a": "Mindest-Kategorie-Erfahrungspunkte",
    "438e079b21c4": "Mindest-Vertrauen (optional)"
  },
  "effectDescriptions": {
    "CategoryRewardBonus": "{{percent}} % mehr Gesamt- und Kategorie-Erfahrungspunkte bei bestätigten guten Taten in {{category}}.",
    "CategoryExperienceBonus": "{{percent}} % mehr Kategorie-Erfahrungspunkte in {{category}}.",
    "GuildGildexContributionBonus": "{{percent}} % zusätzliche Gruppenpunkte aus eigenen bestätigten Einzelaktionen für deine Gruppe.",
    "HeroicActionXpBonus": "{{percent}} % mehr Erfahrungspunkte bei bestätigten guten Taten.",
    "PartyBuff": "{{percent}} % mehr Gruppen-Erfahrungspunkte. Mehrere gleiche Schwerpunktboni werden nicht addiert.",
    "KarmaBonus": "{{value}} zusätzliches Vertrauen pro bestätigter guter Tat, auch bei Gruppenaktionen.",
    "GroupKarmaBonus": "{{value}} zusätzliches Vertrauen bei bestätigten Gruppenaktionen.",
    "KarmaRecoveryBonus": "{{value}} zusätzliches Erholungs-Vertrauen bei negativem Vertrauen.",
    "OtherCategoryExperienceBonus": "{{percent}} % mehr Kategorie-Erfahrungspunkte außerhalb von {{category}}.",
    "WeeklyExperienceElixir": "Einmal pro Kalenderwoche vor einer Einzelaktion aktivieren: {{percent}} % mehr Gesamt- und Kategorie-Erfahrungspunkte bei Bestätigung.",
    "ClassKarmaRecovery": "Bei negativem Vertrauen {{value}} zusätzliches Erholungs-Vertrauen je bestätigter guter Tat, höchstens bis 0."
  },
  "unlocks": {
    "STAMMTISCH": {
      "name": "Gruppenchat",
      "description": "Schaltet den Gruppenchat und internen Text-Chat für eure Gruppenmitglieder frei."
    },
    "DEPUTY_ADMIN": {
      "name": "Weitere Gruppenleitung",
      "description": "Ermöglicht der Gruppenleitung das Ernennen von Stellvertretern, die bei der Verwaltung helfen."
    },
    "HALL_THEME_FOREST": {
      "name": "Gruppenlayout Natur",
      "description": "Gestalte eure Gruppenübersicht mit ruhigen Naturfarben."
    },
    "GROUP_HEROIC_ACTIONS": {
      "name": "Gemeinsame gute Taten",
      "description": "Erlaubt eurer Gruppe, gemeinsame gute Taten zu starten und als Team größere Vorhaben umzusetzen."
    },
    "GUILD_EMOJI_PACK": {
      "name": "Gruppenchat Plus",
      "description": "Schaltet Gruppenreaktionen, Nachrichtenreaktionen, angeheftete Nachrichten und Umfragen im Gruppenchat frei."
    },
    "BANNER_FORGE_ADVANCED": {
      "name": "Erweiterter Logo-Editor",
      "description": "Schaltet erweiterte Bearbeitungs- und Gestaltungsoptionen für euer Gruppenlogo frei."
    },
    "TROPHY_ROOM": {
      "name": "Gemeinsame Erfolge"
    },
    "HALL_THEME_CELESTIAL": {
      "name": "Gruppenlayout Sterne",
      "description": "Gestalte eure Gruppenübersicht mit dem Layout Sterne."
    },
    "EXP_BOOST_1": {
      "name": "Erfahrungsbonus I",
      "description": "Gewährt allen Gruppenmitgliedern passiv +1% Erfahrungspunkte bei ihren guten Taten."
    },
    "EXP_BOOST_2": {
      "name": "Erfahrungsbonus II",
      "description": "Gewährt allen Gruppenmitgliedern passiv +2% Erfahrungspunkte bei ihren guten Taten."
    },
    "EXP_BOOST_3": {
      "name": "Erfahrungsbonus III",
      "description": "Gewährt allen Gruppenmitgliedern passiv +3% Erfahrungspunkte bei ihren guten Taten."
    },
    "EXP_BOOST_4": {
      "name": "Erfahrungsbonus IV",
      "description": "Gewährt allen Gruppenmitgliedern passiv +4% Erfahrungspunkte bei ihren guten Taten."
    },
    "EXP_BOOST_5": {
      "name": "Erfahrungsbonus V",
      "description": "Gewährt allen Gruppenmitgliedern passiv +5% Erfahrungspunkte bei ihren guten Taten."
    }
  },
  "legalContent": {
    "title": "Rechtliches & Datenschutz",
    "updated": "Stand: 28. September 2026",
    "tabs": [
      "Impressum",
      "Nutzungsbedingungen",
      "Datenschutz"
    ],
    "sections": [
      [
        [
          "Diensteanbieter",
          [
            "Goodvale",
            "Betreiber: Dipl. Ing. Thomas Johannes Trügler",
            "Kontakt: thomas@truegler.io",
            "Datenschutz: thomas@truegler.io"
          ]
        ]
      ],
      [
        [
          "1. Plattformzweck",
          [
            "Goodvale ist eine Gamification-Plattform für freiwillige, selbst gemeldete gute Taten. Die Community-Prüfung prüft Nachweise und vergibt Erfahrungspunkte. Erfahrungspunkte bilden Spielfortschritt ab, sind nicht übertragbar, nicht auszahlbar und haben keinen festen Geldwert."
          ]
        ],
        [
          "2. Freiwilligkeit und keine verdeckte Arbeit",
          [
            "Gute Taten dürfen keine Beschäftigung, Arbeitsschicht oder reguläre kommerzielle Dienstleistung ersetzen. Gruppenaktionen müssen freiwillig, sicher und nichtkommerziell organisiert sein. Partner dürfen keine Aufträge über Gruppen oder gute Taten steuern und sind nur für selbst angebotene Vorteile verantwortlich."
          ]
        ],
        [
          "3. Einreichung und Beweise",
          [
            "Einreichende müssen wahrheitsgemäße Angaben machen, Rechte an hochgeladenen Dateien besitzen und unnötige personenbezogene Daten Dritter vermeiden. Gefährliche, rechtswidrige oder manipulierte Aktivitäten werden nicht belohnt. Externe Beweislinks sind nicht zulässig."
          ]
        ],
        [
          "4. Community-Prüfung und Einspruch",
          [
            "Die erste zugewiesene Prüfung legt Schwierigkeit, Komplexität und Basis-Erfahrungspunkte innerhalb der festgelegten Spanne fest. Die Erfahrungspunkte-Höhe bestimmt die Zahl unabhängiger Prüfungen; hohe Werte benötigen zusätzlich einen Admin. Erst das vollständige Quorum entscheidet per Mehrheit. Bei Gleichstand wird eine weitere Prüfung zugewiesen. Gegen eine Ablehnung kann innerhalb der konfigurierten Frist Einspruch erhoben werden."
          ]
        ],
        [
          "5. Gruppenaktionen",
          [
            "Gruppenleitungen dürfen freiwillige Gruppenaktionen ausrufen. Mitglieder melden sich selbst an und bestätigen ihre tatsächliche Teilnahme erst ab Beginn. Organisierende verteilen die Gesamt-Erfahrungspunkte auf bestätigte Teilnehmende; niemand darf mehr als 50 % erhalten. Die Community-Prüfung prüft die Verteilung. Organisierende bleiben für Genehmigungen, Sicherheit und die nichtkommerzielle Durchführung verantwortlich."
          ]
        ],
        [
          "5a. Gruppenpunkte",
          [
            "Gruppenpunkte sind nicht käufliche, nicht übertragbare und nicht auszahlbare interne Gruppen-Fortschrittspunkte ohne Geldwert. Sie werden zusätzlich zu Spieler-Erfahrungspunkten aus einem administrierbaren Anteil bestätigter Basis-Erfahrungspunkte erzeugt und können ausschließlich für interne Gruppenlayouts und Komfortfunktionen verwendet werden. Sie gelten nicht bei Partnern oder außerhalb von Goodvale."
          ]
        ],
        [
          "6. Partnerangebote",
          [
            "Partner legen Freischaltungen anhand von Rang, Level, Gesamt-Erfahrungspunkten, Kategorie-Fortschritt oder einer bestätigten Systemaktion fest. Erfahrungspunkte werden bei der Einlösung nicht verbraucht. Einlösungen erfordern einen kurz gültigen, signierten QR-Pass; jede QR-Sitzung kann nur einmal verwendet werden. Vertrag, Verfügbarkeit und Erfüllung des Vorteils liegen beim Partner."
          ]
        ],
        [
          "7. Schwerpunkte, Boosts und Vertrauen",
          [
            "Schwerpunkt- und Vorteilsboni verändern ausschließlich Spielwerte. Der Erfahrungsbonus im Schwerpunkt Ernährung & Lebensmittel ist kostenlos und einmal pro Kalenderwoche verfügbar. Die Einreichung verbraucht die Ladung auch bei späterer Ablehnung oder Rückzug. Vertrauen bleibt ein separater Vertrauens- und Regelwert."
          ]
        ],
        [
          "8. Sicherheit und Sanktionen",
          [
            "Mehrfachverwendung von Beweisen, QR-Manipulation, Täuschung, Belästigung oder Umgehungsversuche können zur Ablehnung, Einschränkung oder Sperre führen."
          ]
        ],
        [
          "9. Haftung",
          [
            "Goodvale prüft Plattformnachweise, garantiert aber weder die Sicherheit einer Tätigkeit vor Ort noch behördliche Genehmigungen oder die Erfüllung eines Partnerangebots. Gesetzliche Haftung, insbesondere für Vorsatz, grobe Fahrlässigkeit und Personenschäden, bleibt unberührt."
          ]
        ],
        [
          "10. Teilnahme, Registrierung und Vertrag",
          [
            "Goodvale richtet sich an Personen ab 18 Jahren. Mit der Registrierung bestätigst du deine Volljährigkeit und akzeptierst diese Nutzungsbedingungen. Der Nutzungsvertrag kommt mit der Freischaltung des Kontos zustande; Partnerkonten benötigen eine gesonderte Freigabe. Angaben müssen zutreffend sein. Schütze deine Zugangsdaten und melde einen vermuteten Missbrauch. Die Registrierung begründet keinen Anspruch auf bestimmte Partnerangebote oder Belohnungen."
          ]
        ],
        [
          "11. Rechte an Inhalten",
          [
            "Deine Inhalte bleiben deine Inhalte. Du räumst Goodvale nur die nicht ausschließlichen Nutzungsrechte ein, die zum Speichern, technisch erforderlichen Bearbeiten, Anzeigen im von dir gewählten Sichtbarkeitsbereich und Prüfen erforderlich sind. Eine darüber hinausgehende Werbenutzung benötigt eine gesonderte Erlaubnis. Du darfst nur Inhalte hochladen, für die du die erforderlichen Rechte besitzt. Bei Löschung enden die Nutzungsrechte, soweit keine zulässige Aufbewahrung oder Abwicklung offener Verfahren erforderlich ist."
          ]
        ],
        [
          "12. Kündigung und Änderungen",
          [
            "Du kannst die Nutzung jederzeit beenden und dein Konto im Profil löschen oder die Kündigung unter thomas@truegler.io erklären. Bei Gruppenleitung kann zuvor die Übergabe der Leitung oder Auflösung der Gruppe erforderlich sein; dein Recht zur Kündigung bleibt bestehen. Eine sofortige Sperre aus wichtigem Grund bleibt möglich, insbesondere bei erheblichen Rechtsverletzungen oder Sicherheitsgefahren.",
            "Wesentliche Änderungen der Nutzungsbedingungen werden vor ihrem Wirksamwerden verständlich angekündigt. Soweit eine Zustimmung erforderlich ist, holen wir sie ausdrücklich ein; Schweigen gilt nicht als Zustimmung. Du kannst vor Wirksamwerden kündigen. Technische Wartung und Weiterentwicklung können die Verfügbarkeit und Spielregeln verändern; zwingende gesetzliche Rechte bleiben bestehen."
          ]
        ],
        [
          "13. Meldung rechtswidriger Inhalte",
          [
            "Nutzer und Behörden erreichen unsere Kontaktstelle unter thomas@truegler.io in deutscher oder englischer Sprache. Für Inhaltsmeldungen verwende möglichst den Betreff „Inhaltsmeldung“ und nenne den genauen Link oder die eindeutige Inhaltskennung, den Grund der vermuteten Rechtswidrigkeit und gegebenenfalls Belege. Gib Namen und E-Mail-Adresse sowie eine Erklärung an, dass deine Angaben nach bestem Wissen richtig und vollständig sind; gesetzliche Ausnahmen von Identitätsangaben bleiben unberührt.",
            "Wir bestätigen den Eingang, prüfen Meldungen sorgfältig und unparteiisch und informieren über die Entscheidung und mögliche Rechtsbehelfe, soweit uns Kontaktdaten vorliegen. Übermittle keine unnötigen sensiblen Daten. Diese Kontaktstelle ist kein Notruf."
          ]
        ],
        [
          "14. Moderation und Beschwerden",
          [
            "Verboten sind insbesondere rechtswidrige Inhalte, Drohungen, Belästigung, Veröffentlichung privater Daten Dritter, Rechteverletzungen und manipulierte Nachweise. Je nach Schwere, Wiederholung und Gefährdung können Inhalte eingeschränkt oder entfernt, Einreichungen abgelehnt und Konten vorübergehend oder dauerhaft gesperrt werden. Automatische Prüfungen unterstützen die Erkennung und Zuweisung; strittige Maßnahmen werden von Menschen überprüft.",
            "Betroffene erhalten, soweit rechtlich zulässig, eine verständliche Begründung mit maßgeblichen Umständen, Regelgrundlage, Umfang und Dauer der Maßnahme sowie dem Beschwerdeweg. Gegen Moderationsmaßnahmen kannst du innerhalb von sechs Monaten kostenlos unter thomas@truegler.io mit dem Betreff „Moderationsbeschwerde“ vorgehen. Nenne die Entscheidung und deine Einwände. Die Überprüfung erfolgt durch eine befugte Person und nicht ausschließlich automatisiert. Fehlerhafte Maßnahmen werden korrigiert. Für Erfahrungspunkte- und Tatentscheidungen gilt zusätzlich der in der App angezeigte Einspruchsweg der Community-Prüfung. Gesetzliche gerichtliche und außergerichtliche Rechtsbehelfe bleiben unberührt."
          ]
        ],
        [
          "15. Anwendbares Recht",
          [
            "Es gilt österreichisches Recht. Zwingende Verbraucherschutzvorschriften deines gewöhnlichen Aufenthaltsstaats bleiben anwendbar, soweit gesetzlich vorgesehen. Gesetzliche Gerichtsstände werden nicht eingeschränkt."
          ]
        ]
      ],
      [
        [
          "1. Verantwortlicher",
          [
            "Verantwortlicher ist der im Impressum genannte Betreiber. Datenschutzanfragen: thomas@truegler.io."
          ]
        ],
        [
          "2. Verarbeitete Daten und Zwecke",
          [
            "Verarbeitet werden Konto- und Profildaten, Fortschritt, Vertrauen, Gruppenmitgliedschaft, Gruppenpunkte-Buchungen und Freischaltungen, Einreichungen, Entscheidungen der Community-Prüfung, Einsprüche, Partner-Einlösungen, Nachrichten, Push-Abonnements sowie Sicherheits- und Zugriffsprotokolle. Zwecke sind Kontoführung, Spielbetrieb, Missbrauchsschutz, Kommunikation und Nachweisprüfung."
          ]
        ],
        [
          "3. Rechtsgrundlagen",
          [
            "Kontoführung, Kommunikation, Prüfung eingereichter Taten und Einlösung von Vorteilen erfolgen, soweit dafür erforderlich, nach Art. 6 Abs. 1 lit. b DSGVO. Optionale Umami-Statistik und Sentry-Fehlerdiagnose im Browser beruhen jeweils auf deiner gesonderten Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO. Sicherheitsprotokolle, serverseitige Fehlerdiagnose und Missbrauchsabwehr dienen unseren berechtigten Interessen am sicheren und fairen Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Gesetzliche Aufbewahrungs- und Auskunftspflichten erfüllen wir nach Art. 6 Abs. 1 lit. c DSGVO.",
            "E-Mail-Adresse, Zugangsdaten und die für deine Rolle erforderlichen Angaben sind für ein Konto notwendig. Ohne diese Angaben kann kein Konto bereitgestellt werden. Optionale Angaben und Tracking-Einwilligungen sind keine Voraussetzung für die allgemeine Nutzung. Du kannst Einwilligungen jederzeit für die Zukunft widerrufen; die Rechtmäßigkeit der bisherigen Verarbeitung bleibt unberührt."
          ]
        ],
        [
          "4. Beweisdatenschutz",
          [
            "Die Verarbeitung eines von dir gewählten Nachweises dient der von dir angeforderten Prüfung deiner Tat (Art. 6 Abs. 1 lit. b DSGVO). Die Bestätigung vor dem Upload bestätigt die Beweisregeln; sie ist keine pauschale Einwilligung in beliebige Datenverarbeitung. Dateien werden verschlüsselt außerhalb öffentlicher Webverzeichnisse gespeichert. Zugriff erhalten die einreichende Person, zugewiesene Prüfer und berechtigte Administratoren; Zugriffe werden protokolliert.",
            "Lade nur erforderliche Nachweise hoch. Mache unbeteiligte Personen, Kennzeichen und private Anschriften unkenntlich. Lade keine Gesundheitsunterlagen, Ausweisdokumente oder anderen sensiblen Angaben über dich oder Dritte hoch. Die Uploadbestätigung ersetzt keine Rechte oder Rechtsgrundlage für Daten Dritter.",
            "Ab Prüfungsbeginn ist die direkte Selbstlöschung einzelner Beweise eingeschränkt, um das Verfahren nachvollziehbar zu halten. Du kannst dennoch jederzeit unter thomas@truegler.io Löschung, Einschränkung oder Rücknahme der Einreichung beantragen. Wir prüfen den Einzelfall; eine weitere Aufbewahrung erfolgt nur bei einer tragfähigen Rechtsgrundlage, etwa zur notwendigen Rechtsverteidigung. Die technische Einschränkung hebt deine gesetzlichen Rechte nicht auf."
          ]
        ],
        [
          "5. Empfänger und Auftragsverarbeiter",
          [
            "Daten erhalten nur technisch oder fachlich notwendige Empfänger, etwa Hosting-, Push- oder Sicherheitsdienstleister auf vertraglicher Grundlage. Partner sehen beim QR-Scan nur die für Berechtigung und Einlösung erforderlichen Daten."
          ]
        ],
        [
          "5a. Hetzner – Hosting",
          [
            "Wir nutzen Hetzner Online GmbH für die Hosting-Infrastruktur von Goodvale. Dabei werden die für den Plattformbetrieb gespeicherten Daten sowie technische Verbindungs- und Zugriffsdaten, insbesondere IP-Adresse, Zeitpunkt und angeforderte Ressourcen, verarbeitet. Dies dient der Bereitstellung, Verfügbarkeit und Sicherheit der Plattform auf Grundlage der Vertragserfüllung und unserer berechtigten Interessen an einem sicheren Betrieb."
          ],
          "https://www.hetzner.com/legal/privacy-policy/"
        ],
        [
          "5b. Sentry – Fehlerdiagnose",
          [
            "Sentry dient der Erkennung und Behebung technischer Fehler. Dabei können Fehlermeldungen, Stacktraces, technische Browser-, Geräte- und Anfragedaten sowie Leistungsdaten verarbeitet werden. Die Fehlererfassung im Browser wird erst nach deiner Einwilligung aktiviert und kann über die Tracking-Einstellungen widerrufen werden. Die automatische Übermittlung zusätzlicher personenbezogener Daten ist im Browser deaktiviert. Die serverseitige Fehler- und Leistungsdiagnose erfolgt unabhängig davon zur Sicherung des Betriebs auf Grundlage unserer berechtigten Interessen."
          ],
          "https://sentry.io/privacy/"
        ],
        [
          "5c. Umami – Nutzungsstatistik",
          [
            "Umami erfasst nach deiner Einwilligung Seitenaufrufe und technische Nutzungsdaten, etwa aufgerufene URLs, Verweisquellen sowie Browser- und Geräteinformationen. Wir nutzen diese Statistik, um die Nutzung und Bedienbarkeit von Goodvale zu verstehen und zu verbessern. Du kannst die Erfassung jederzeit in den Tracking-Einstellungen deaktivieren. Die Verarbeitung erfolgt über die für Goodvale konfigurierte Umami-Instanz."
          ],
          "https://docs.umami.is/"
        ],
        [
          "5d. Firebase – Push-Benachrichtigungen",
          [
            "Für Push-Benachrichtigungen auf Android verwenden wir Firebase Cloud Messaging von Google. Dabei werden Geräte-Registrierungstoken, technische Zustellungsdaten und die Benachrichtigungsdaten verarbeitet. Goodvale versendet einen allgemeinen Hinweis auf neue Benachrichtigungen sowie Typ und Referenzkennung, keine Nachrichtentexte aus Chats. Die Zustellung erfolgt nach Aktivierung und Erteilung der Geräteberechtigung. Du kannst Push-Benachrichtigungen in den Geräteeinstellungen deaktivieren."
          ],
          "https://firebase.google.com/support/privacy"
        ],
        [
          "5e. Resend – E-Mail-Versand",
          [
            "Resend versendet transaktionale Kontomails, insbesondere zur Bestätigung deiner E-Mail-Adresse und zum Zurücksetzen des Passworts. Dazu werden Empfängeradresse, E-Mail-Inhalt einschließlich Bestätigungs- oder Rücksetzlink sowie technische Versand- und Zustellungsdaten verarbeitet. Dies dient der Kontoführung und Kontosicherheit auf Grundlage der Vertragserfüllung und unserer berechtigten Interessen am Schutz von Nutzerkonten."
          ],
          "https://resend.com/legal/privacy-policy"
        ],
        [
          "5f. Karten und Standort",
          [
            "Karten werden mit Kacheln der OpenStreetMap Foundation geladen. Beim Öffnen einer Kartenfunktion werden insbesondere IP-Adresse, technische Anfragedaten und der angeforderte Kartenausschnitt an deren Server übermittelt. Dies dient der angeforderten Kartenanzeige und unserem berechtigten Interesse an einer funktionierenden Ortsdarstellung. Der Kartenausschnitt kann Rückschlüsse auf den betrachteten Ort zulassen.",
            "Die Standortfreigabe deines Geräts ist optional und erfordert dessen Berechtigung. Manuell angegebene Standorte, öffentliche Gruppen- oder Partnerorte und freiwillige GPS-Nachweise werden für die jeweilige Funktion verarbeitet. Öffentlich eingegebene Orte sind für andere sichtbar; GPS-Nachweise gehören zur geschützten Einreichung."
          ],
          "https://osmfoundation.org/wiki/Privacy_Policy"
        ],
        [
          "5g. Apple-Push auf iOS",
          [
            "Auf iOS erfolgt die Zustellung über Apple Push Notification service (APNs). Verarbeitet werden Gerätetoken, technische Zustellungsdaten, ein allgemeiner Benachrichtigungshinweis sowie Typ und Referenzkennung. Die Funktion setzt deine Aktivierung und Geräteberechtigung voraus; diese kannst du in den Geräteeinstellungen widerrufen."
          ],
          "https://www.apple.com/legal/privacy/"
        ],
        [
          "5h. Sichtbarkeit und Empfänger innerhalb von Goodvale",
          [
            "Öffentliche Profilangaben wie Nutzername, gewähltes Profilbild, Beschreibung und angezeigter Spielfortschritt können anderen Nutzern beziehungsweise Besuchern angezeigt werden. Veröffentliche dort keine vertraulichen Angaben. Gruppeninhalte sind entsprechend der jeweiligen öffentlichen oder mitgliederbezogenen Funktion sichtbar. Direktnachrichten sind für die Gesprächsbeteiligten, Gruppenchats für die jeweiligen Mitglieder bestimmt. Berechtigte Administratoren können Daten bearbeiten, soweit dies für Betrieb, Support oder die Prüfung konkreter Missbrauchsmeldungen erforderlich ist.",
            "Mitglieder der Community-Prüfung erhalten nur im Rahmen ihrer Zuweisung Zugriff auf geschützte Nachweise. Partner erhalten die für eine Einlösung erforderlichen Berechtigungs- und Einlösungsangaben. Plattformdaten werden nicht allein dadurch öffentlich, dass sie für eine Prüfung eingereicht werden."
          ]
        ],
        [
          "5i. Regionen und internationale Übermittlungen",
          [
            "Die Hosting-Infrastruktur bei Hetzner und die dort selbst betriebene Umami-Instanz liegen in Europa. Bei externen Diensten verwenden wir die verfügbaren und konfigurierten EU-Datenregionen. Eine EU-Speicherregion schließt Zugriffe oder Verarbeitung durch internationale Anbieter und Unterauftragnehmer außerhalb des EWR nicht automatisch aus, insbesondere bei weltweiten Push- und E-Mail-Diensten.",
            "Für Übermittlungen außerhalb des EWR ist ein Angemessenheitsbeschluss nach Art. 45 DSGVO oder eine geeignete Garantie nach Art. 46 DSGVO erforderlich, insbesondere EU-Standardvertragsklauseln mit gegebenenfalls zusätzlichen Schutzmaßnahmen. Eine Zertifizierung unter dem EU-US Data Privacy Framework kann nur herangezogen werden, soweit der konkrete Empfänger und die Verarbeitung davon erfasst sind. Informationen zu den für deine Daten einschlägigen Empfängern, Garantien und einer Kopie der Garantien erhältst du unter thomas@truegler.io."
          ]
        ],
        [
          "6. Speicherdauer",
          [
            "Kontodaten bleiben für die Dauer des Kontos gespeichert. Bei Kontolöschung werden insbesondere Kontaktdaten, Profilinhalte, Standortangaben, Beweise, Push-Abonnements sowie zugehörige Direkt- und eigene Gruppenchatnachrichten gelöscht oder bereinigt. Laufende Einreichungen werden zurückgezogen. Pseudonymisierte Prüf- und Buchungsdaten können verbleiben; sie sind weiterhin personenbezogene Daten, soweit eine Zuordnung möglich ist.",
            "Für Beweise ist im System eine Regelfrist von 90 Tagen nach der endgültigen Entscheidung vorgesehen, mindestens jedoch bis sieben Tage nach Ende der anwendbaren Einspruchsfrist. Offene Verfahren und Einsprüche sind zu berücksichtigen. Eine abweichend erforderliche Aufbewahrung muss durch den konkreten Verfahrenszweck oder eine gesetzliche Grundlage gerechtfertigt sein.",
            "Für Sicherheits-, Diagnose-, Versand- und Prüfprotokolle richtet sich die erforderliche Dauer nach Fehlerbehebung, Zustellungsnachweis, Aufklärung eines konkreten Missbrauchsfalls oder Abwehr von Ansprüchen. Nicht mehr erforderliche personenbezogene Daten sind zu löschen oder tatsächlich zu anonymisieren; abgeschlossene Fälle rechtfertigen keine unbegrenzte Vorratsspeicherung. Bei gesetzlichen Pflichten gilt die jeweils einschlägige Frist. Lokale Einstellungen bleiben bis zur Änderung oder Löschung des Browserspeichers erhalten."
          ]
        ],
        [
          "7. Deine Rechte",
          [
            "Du kannst im Profil eine maschinenlesbare Datenkopie herunterladen und dein Konto anonymisieren. Zusätzlich bestehen – soweit gesetzlich anwendbar – Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerspruch und Beschwerde bei der österreichischen Datenschutzbehörde."
          ]
        ],
        [
          "8. Kontoanonymisierung",
          [
            "Bei Selbstlöschung werden Kontaktdaten und Beweisdateien entfernt und der Zugang gesperrt. Prüf-, Ledger- und Sicherheitsdatensätze können pseudonymisiert fortbestehen, wenn sie zur Integrität des Systems oder wegen gesetzlicher Pflichten benötigt werden."
          ]
        ],
        [
          "9. Rechte, Widerspruch und Kontakt",
          [
            "Für Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit oder Widerruf erreichst du uns unter thomas@truegler.io oder der Anschrift im Impressum. Gegen Verarbeitungen auf Grundlage berechtigter Interessen kannst du aus Gründen deiner besonderen Situation Widerspruch einlegen. Wir beantworten Anträge grundsätzlich innerhalb eines Monats; eine gesetzlich zulässige Verlängerung teilen wir mit Gründen mit. Du kannst dich bei der österreichischen Datenschutzbehörde beschweren."
          ],
          "https://dsb.gv.at/"
        ],
        [
          "10. Lokaler Speicher und automatisierte Regeln",
          [
            "Für Anmeldung, Sprache, Darstellung und Datenschutzentscheidungen verwenden wir lokalen Browserspeicher. Optionale Umami-Statistik und Sentry-Browserdiagnose sind getrennt wählbar und standardmäßig ausgeschaltet. Die Ablehnung beeinträchtigt die allgemeine Nutzung nicht. Über die Einstellungen unten kannst du deine Entscheidung ändern.",
            "Erfahrungspunkte, Freischaltungen, Vertrauenseffekte und Anti-Cheat-Prüfungen werden teilweise regelbasiert berechnet. Die Regeln betreffen den Spielfortschritt und die Prüfungszuweisung; Entscheidungen der Community-Prüfung werden durch zugewiesene Menschen getroffen. Bei strittigen Ergebnissen kannst du eine menschliche Prüfung über die Einspruchsfunktion oder thomas@truegler.io verlangen."
          ]
        ]
      ]
    ]
  },
  "classAvailability": {
    "bonus": "Erfahrungsbonus"
  }
}
